import { Injectable, ɵɵdefineInjectable, ɵɵinject, Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation, NgModule } from '@angular/core';
import { HttpHeaders, HttpClient, HttpClientModule } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { messageType, MessageService } from 'ui-message-angular';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { v4 } from 'uuid';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/entity.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from 'ui-message-angular';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@angular/common';

function SearchHelpComponent_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelementStart(1, "input", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function SearchHelpComponent_div_10_div_1_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.fuzzySearchTerm = $event; })("keyup", function SearchHelpComponent_div_10_div_1_Template_input_keyup_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.enterSearch($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.fuzzySearchTerm);
} }
function SearchHelpComponent_div_10_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵelementStart(1, "label", 28);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 29);
    ɵngcc0.ɵɵlistener("keyup", function SearchHelpComponent_div_10_div_3_Template_input_keyup_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.enterSearch($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const filterField_r11 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("for", filterField_r11.FIELD_NAME);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", filterField_r11.LABEL_TEXT || filterField_r11.FIELD_NAME, ":");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("id", filterField_r11.FIELD_NAME);
    ɵngcc0.ɵɵpropertyInterpolate("name", filterField_r11.FIELD_NAME);
    ɵngcc0.ɵɵpropertyInterpolate("formControlName", filterField_r11.FIELD_NAME);
    ɵngcc0.ɵɵproperty("readonly", filterField_r11.FILTER_DISP_ONLY);
} }
function SearchHelpComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtemplate(1, SearchHelpComponent_div_10_div_1_Template, 2, 1, "div", 20);
    ɵngcc0.ɵɵelementStart(2, "div", 21);
    ɵngcc0.ɵɵtemplate(3, SearchHelpComponent_div_10_div_3_Template, 4, 6, "div", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 23);
    ɵngcc0.ɵɵelementStart(5, "button", 24);
    ɵngcc0.ɵɵlistener("click", function SearchHelpComponent_div_10_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.search(); });
    ɵngcc0.ɵɵtext(6, " Search ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.searchHelp && ctx_r0.searchHelp.FUZZY_SEARCH);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.filterFieldsFormGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.filterFields);
} }
function SearchHelpComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 30);
    ɵngcc0.ɵɵlistener("click", function SearchHelpComponent_button_11_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.showFilter(); });
    ɵngcc0.ɵɵtext(1, "Show Filter");
    ɵngcc0.ɵɵelementEnd();
} }
function SearchHelpComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 30);
    ɵngcc0.ɵɵlistener("click", function SearchHelpComponent_button_12_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.hideFilter(); });
    ɵngcc0.ɵɵtext(1, "Hide Filter");
    ɵngcc0.ɵɵelementEnd();
} }
function SearchHelpComponent_input_17_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 31);
    ɵngcc0.ɵɵlistener("ngModelChange", function SearchHelpComponent_input_17_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.isSelectAllChecked = $event; })("click", function SearchHelpComponent_input_17_Template_input_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.selectAll(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.isSelectAllChecked);
} }
function SearchHelpComponent_th_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const listField_r23 = ctx.$implicit;
    ɵngcc0.ɵɵstyleProp("display", listField_r23.FIELD_NAME === "INSTANCE_GUID" ? "none" : "table-cell");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", listField_r23.LIST_HEADER_TEXT || listField_r23.FIELD_NAME, " ");
} }
function SearchHelpComponent_tr_20_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 34);
    ɵngcc0.ɵɵlistener("ngModelChange", function SearchHelpComponent_tr_20_input_2_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(2); return ctx_r29.selectedIndex = $event; })("dblclick", function SearchHelpComponent_tr_20_input_2_Template_input_dblclick_0_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r31 = ɵngcc0.ɵɵnextContext(2); return ctx_r31.confirmSelection(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r25 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r26 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("value", i_r25)("ngModel", ctx_r26.selectedIndex);
} }
function SearchHelpComponent_tr_20_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 35);
    ɵngcc0.ɵɵlistener("ngModelChange", function SearchHelpComponent_tr_20_input_3_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); const item_r24 = ɵngcc0.ɵɵnextContext().$implicit; return item_r24.SELECTED = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r24 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngModel", item_r24.SELECTED);
} }
function SearchHelpComponent_tr_20_td_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const listField_r37 = ctx.$implicit;
    const item_r24 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵstyleProp("display", listField_r37.FIELD_NAME === "INSTANCE_GUID" ? "none" : "table-cell");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r24[listField_r37.FIELD_NAME], " ");
} }
function SearchHelpComponent_tr_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵtemplate(2, SearchHelpComponent_tr_20_input_2_Template, 1, 2, "input", 32);
    ɵngcc0.ɵɵtemplate(3, SearchHelpComponent_tr_20_input_3_Template, 1, 1, "input", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, SearchHelpComponent_tr_20_td_4_Template, 2, 3, "td", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.searchHelp.MULTI);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.searchHelp.MULTI);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.listFields);
} }
const _c0 = function (a0) { return { "show": a0 }; };
const _c1 = function (a0) { return { "display": a0 }; };
function AttributeComponent_div_2_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 16);
    ɵngcc0.ɵɵlistener("change", function AttributeComponent_div_2_input_1_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.onChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("form-control-sm", ctx_r9.isSmallSize);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r9.attributeControl.name)("id", ctx_r9.attributeControl.key)("maxlength", ctx_r9.attributeControl.maxLength)("pattern", ctx_r9.attributeControl.pattern)("readonly", ctx_r9.isReadonly);
} }
function AttributeComponent_div_2_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 17);
    ɵngcc0.ɵɵlistener("keyup", function AttributeComponent_div_2_input_2_Template_input_keyup_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.onKeyup(ctx_r15.attributeControl.name); })("change", function AttributeComponent_div_2_input_2_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.onChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("form-control-sm", ctx_r10.isSmallSize);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r10.attributeControl.name)("id", ctx_r10.attributeControl.key)("maxlength", ctx_r10.attributeControl.maxLength)("readonly", ctx_r10.isReadonly);
} }
function AttributeComponent_div_2_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 18);
    ɵngcc0.ɵɵlistener("change", function AttributeComponent_div_2_input_3_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.onChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("form-control-sm", ctx_r11.isSmallSize);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r11.attributeControl.name)("id", ctx_r11.attributeControl.key)("pattern", ctx_r11.attributeControl.pattern)("readonly", ctx_r11.isReadonly);
} }
function AttributeComponent_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "button", 20);
    ɵngcc0.ɵɵlistener("click", function AttributeComponent_div_2_div_4_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.onSearchHelp(ctx_r20.attributeControl); });
    ɵngcc0.ɵɵelement(2, "span", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function AttributeComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, AttributeComponent_div_2_input_1_Template, 1, 7, "input", 12);
    ɵngcc0.ɵɵtemplate(2, AttributeComponent_div_2_input_2_Template, 1, 6, "input", 13);
    ɵngcc0.ɵɵtemplate(3, AttributeComponent_div_2_input_3_Template, 1, 6, "input", 14);
    ɵngcc0.ɵɵtemplate(4, AttributeComponent_div_2_div_4_Template, 3, 0, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "text");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "text_capital");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "integer");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.attributeControl.searchHelpId || ctx_r0.attributeControl.domainRelationId);
} }
function AttributeComponent_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 22);
    ɵngcc0.ɵɵlistener("change", function AttributeComponent_input_3_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.onChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("form-control-sm", ctx_r1.isSmallSize);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r1.attributeControl.name)("id", ctx_r1.attributeControl.key)("step", ctx_r1.attributeControl.step)("placeholder", ctx_r1.attributeControl.placeholder)("pattern", ctx_r1.attributeControl.pattern)("readonly", ctx_r1.isReadonly);
} }
function AttributeComponent_input_4_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 23);
    ɵngcc0.ɵɵlistener("change", function AttributeComponent_input_4_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.onChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("form-control-sm", ctx_r2.isSmallSize);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r2.attributeControl.name)("id", ctx_r2.attributeControl.key);
} }
function AttributeComponent_input_5_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 24);
    ɵngcc0.ɵɵlistener("change", function AttributeComponent_input_5_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.onChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("form-control-sm", ctx_r3.isSmallSize);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r3.attributeControl.name)("id", ctx_r3.attributeControl.key)("readonly", ctx_r3.isReadonly);
} }
function AttributeComponent_input_6_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 25);
    ɵngcc0.ɵɵlistener("change", function AttributeComponent_input_6_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r29); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.onChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("form-control-sm", ctx_r4.isSmallSize);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r4.attributeControl.name)("id", ctx_r4.attributeControl.key)("readonly", ctx_r4.isReadonly);
} }
function AttributeComponent_input_7_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 26);
    ɵngcc0.ɵɵlistener("change", function AttributeComponent_input_7_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(); return ctx_r30.onChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("form-control-sm", ctx_r5.isSmallSize);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r5.attributeControl.name)("id", ctx_r5.attributeControl.key)("readonly", ctx_r5.isReadonly);
} }
function AttributeComponent_input_8_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 27);
    ɵngcc0.ɵɵlistener("change", function AttributeComponent_input_8_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(); return ctx_r32.onChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("form-control-sm", ctx_r6.isSmallSize);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r6.attributeControl.name)("id", ctx_r6.attributeControl.key)("readonly", ctx_r6.isReadonly);
} }
function AttributeComponent_select_9_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 30);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r35 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", opt_r35.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(opt_r35.value);
} }
function AttributeComponent_select_9_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 28);
    ɵngcc0.ɵɵlistener("change", function AttributeComponent_select_9_Template_select_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r36 = ɵngcc0.ɵɵnextContext(); return ctx_r36.onChange($event); });
    ɵngcc0.ɵɵtemplate(1, AttributeComponent_select_9_option_1_Template, 2, 2, "option", 29);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("form-control-sm", ctx_r7.isSmallSize);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r7.attributeControl.name)("id", ctx_r7.attributeControl.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.attributeControl.dropdownList);
} }
function AttributeComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("ng-invalid", ctx_r8.invalid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r8.errorMessage, " ");
} }
function AttributeFormComponent_strong_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "strong", 4);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function AttributeForm2Component_strong_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "strong", 5);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function AttributeTableComponent_th_5_strong_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "strong", 18);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function AttributeTableComponent_th_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, AttributeTableComponent_th_5_strong_2_Template, 2, 0, "strong", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attributeControl_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attributeControl_r3.label, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", attributeControl_r3.primaryKey);
} }
function AttributeTableComponent_tr_7_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 25);
} }
function AttributeTableComponent_tr_7_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 26);
} }
function AttributeTableComponent_tr_7_td_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵelement(1, "dk-app-attribute", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attributeControl_r10 = ctx.$implicit;
    const formGroup_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("attributeControl", attributeControl_r10)("isSmallSize", ctx_r9.isSmallSize)("formGroup", formGroup_r5)("readonly", ctx_r9.readonly);
} }
function AttributeTableComponent_tr_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 19);
    ɵngcc0.ɵɵelementStart(2, "button", 20);
    ɵngcc0.ɵɵlistener("click", function AttributeTableComponent_tr_7_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r13); const i_r6 = ctx.index; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.openDetailModal(i_r6); });
    ɵngcc0.ɵɵtemplate(3, AttributeTableComponent_tr_7_span_3_Template, 1, 0, "span", 21);
    ɵngcc0.ɵɵtemplate(4, AttributeTableComponent_tr_7_span_4_Template, 1, 0, "span", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 23);
    ɵngcc0.ɵɵlistener("click", function AttributeTableComponent_tr_7_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r13); const i_r6 = ctx.index; const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.deleteRelationInstance(i_r6); });
    ɵngcc0.ɵɵelement(6, "span", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, AttributeTableComponent_tr_7_td_7_Template, 2, 4, "td", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("btn-sm", ctx_r1.isSmallSize);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.readonly);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.readonly);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("btn-sm", ctx_r1.isSmallSize);
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.readonly);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.attributeControls);
} }
function AttributeTableComponent_div_8_dk_app_attribute_form_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dk-app-attribute-form", 32);
} if (rf & 2) {
    const attributeControl_r16 = ctx.$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("readonly", ctx_r15.readonly)("isSmallSize", ctx_r15.isSmallSize)("attributeControl", attributeControl_r16)("formGroup", ctx_r15.currentFormGroup);
} }
function AttributeTableComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵelementStart(1, "div", 29);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵelementStart(3, "div", 10);
    ɵngcc0.ɵɵelementStart(4, "h5", 30);
    ɵngcc0.ɵɵtext(5, "Line Detail");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "button", 12);
    ɵngcc0.ɵɵlistener("click", function AttributeTableComponent_div_8_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.closeDetailModal(); });
    ɵngcc0.ɵɵelementStart(7, "span", 13);
    ɵngcc0.ɵɵtext(8, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 14);
    ɵngcc0.ɵɵtemplate(10, AttributeTableComponent_div_8_dk_app_attribute_form_10_Template, 1, 4, "dk-app-attribute-form", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 15);
    ɵngcc0.ɵɵelementStart(12, "button", 16);
    ɵngcc0.ɵɵlistener("click", function AttributeTableComponent_div_8_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.closeDetailModal(); });
    ɵngcc0.ɵɵtext(13, "OK");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c0, ctx_r2.isDetailModalShown))("ngStyle", ɵngcc0.ɵɵpureFunction1(7, _c1, ctx_r2.displayDetailModal));
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.attributeControls);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("btn-sm", ctx_r2.isSmallSize);
} }
class Entity {
}
if (false) {
    /** @type {?} */
    Entity.prototype.ENTITY_ID;
    /** @type {?} */
    Entity.prototype.INSTANCE_GUID;
    /** @type {?} */
    Entity.prototype.relationships;
    /* Skipping unhandled member: [key: string]: any;*/
}
class Relationship {
}
if (false) {
    /** @type {?} */
    Relationship.prototype.RELATIONSHIP_ID;
    /** @type {?} */
    Relationship.prototype.SELF_ROLE_ID;
    /** @type {?} */
    Relationship.prototype.values;
}
class RelationshipInstance {
}
if (false) {
    /** @type {?} */
    RelationshipInstance.prototype.action;
    /** @type {?} */
    RelationshipInstance.prototype.RELATIONSHIP_INSTANCE_GUID;
    /** @type {?} */
    RelationshipInstance.prototype.VALID_FROM;
    /** @type {?} */
    RelationshipInstance.prototype.VALID_TO;
    /** @type {?} */
    RelationshipInstance.prototype.PARTNER_INSTANCES;
    /* Skipping unhandled member: [key: string]: any;*/
}
class PartnerInstance {
}
if (false) {
    /** @type {?} */
    PartnerInstance.prototype.ENTITY_ID;
    /** @type {?} */
    PartnerInstance.prototype.ROLE_ID;
    /** @type {?} */
    PartnerInstance.prototype.INSTANCE_GUID;
    /* Skipping unhandled member: [key: string]: any;*/
}
class PartnerRole {
}
if (false) {
    /** @type {?} */
    PartnerRole.prototype.ENTITY_ID;
    /** @type {?} */
    PartnerRole.prototype.ROLE_ID;
}
class EntityMeta {
}
if (false) {
    /** @type {?} */
    EntityMeta.prototype.ENTITY_ID;
    /** @type {?} */
    EntityMeta.prototype.ENTITY_DESC;
    /** @type {?} */
    EntityMeta.prototype.VERSION_NO;
    /** @type {?} */
    EntityMeta.prototype.ROLES;
}
class Attribute {
}
if (false) {
    /** @type {?} */
    Attribute.prototype.ATTR_GUID;
    /** @type {?} */
    Attribute.prototype.RELATION_ID;
    /** @type {?} */
    Attribute.prototype.ATTR_NAME;
    /** @type {?} */
    Attribute.prototype.ATTR_DESC;
    /** @type {?} */
    Attribute.prototype.DATA_ELEMENT;
    /** @type {?} */
    Attribute.prototype.SEARCH_HELP_ID;
    /** @type {?} */
    Attribute.prototype.SEARCH_HELP_EXPORT_FIELD;
    /** @type {?} */
    Attribute.prototype.DOMAIN_ID;
    /** @type {?} */
    Attribute.prototype.DOMAIN_TYPE;
    /** @type {?} */
    Attribute.prototype.REG_EXPR;
    /** @type {?} */
    Attribute.prototype.DOMAIN_ENTITY_ID;
    /** @type {?} */
    Attribute.prototype.DOMAIN_RELATION_ID;
    /** @type {?} */
    Attribute.prototype.LABEL_TEXT;
    /** @type {?} */
    Attribute.prototype.LIST_HEADER_TEXT;
    /** @type {?} */
    Attribute.prototype.DATA_TYPE;
    /** @type {?} */
    Attribute.prototype.DATA_LENGTH;
    /** @type {?} */
    Attribute.prototype.DECIMAL;
    /** @type {?} */
    Attribute.prototype.CAPITAL_ONLY;
    /** @type {?} */
    Attribute.prototype.UNSIGNED;
    /** @type {?} */
    Attribute.prototype.ORDER;
    /** @type {?} */
    Attribute.prototype.PRIMARY_KEY;
    /** @type {?} */
    Attribute.prototype.AUTO_INCREMENT;
}
class Role {
}
if (false) {
    /** @type {?} */
    Role.prototype.ROLE_ID;
    /** @type {?} */
    Role.prototype.ROLE_DESC;
    /** @type {?} */
    Role.prototype.CONDITIONAL_ATTR;
    /** @type {?} */
    Role.prototype.CONDITIONAL_VALUE;
    /** @type {?} */
    Role.prototype.RELATIONS;
    /** @type {?} */
    Role.prototype.RELATIONSHIPS;
}
class RoleRelation {
}
if (false) {
    /** @type {?} */
    RoleRelation.prototype.RELATION_ID;
    /** @type {?} */
    RoleRelation.prototype.RELATION_DESC;
    /** @type {?} */
    RoleRelation.prototype.CARDINALITY;
}
class RelationshipMeta {
}
if (false) {
    /** @type {?} */
    RelationshipMeta.prototype.RELATIONSHIP_ID;
    /** @type {?} */
    RelationshipMeta.prototype.RELATIONSHIP_DESC;
    /** @type {?} */
    RelationshipMeta.prototype.VALID_PERIOD;
    /** @type {?} */
    RelationshipMeta.prototype.SINGLETON;
    /** @type {?} */
    RelationshipMeta.prototype.CREATE_BY;
    /** @type {?} */
    RelationshipMeta.prototype.CREATE_TIME;
    /** @type {?} */
    RelationshipMeta.prototype.LAST_CHANGE_BY;
    /** @type {?} */
    RelationshipMeta.prototype.LAST_CHANGE_TIME;
    /** @type {?} */
    RelationshipMeta.prototype.INVOLVES;
}
class Involve {
}
if (false) {
    /** @type {?} */
    Involve.prototype.ROLE_ID;
    /** @type {?} */
    Involve.prototype.ROLE_DESC;
    /** @type {?} */
    Involve.prototype.CARDINALITY;
    /** @type {?} */
    Involve.prototype.DIRECTION;
}
class RelationMeta {
}
if (false) {
    /** @type {?} */
    RelationMeta.prototype.RELATION_ID;
    /** @type {?} */
    RelationMeta.prototype.RELATION_DESC;
    /** @type {?} */
    RelationMeta.prototype.VERSION_NO;
    /** @type {?} */
    RelationMeta.prototype.ATTRIBUTES;
    /** @type {?} */
    RelationMeta.prototype.ASSOCIATIONS;
}
class Association {
}
if (false) {
    /** @type {?} */
    Association.prototype.ASSOCIATION_NAME;
    /** @type {?} */
    Association.prototype.RIGHT_RELATION_ID;
    /** @type {?} */
    Association.prototype.CARDINALITY;
    /** @type {?} */
    Association.prototype.FOREIGN_KEY_CHECK;
    /** @type {?} */
    Association.prototype.FIELDS_MAPPING;
}
class FieldsMappingPair {
}
if (false) {
    /** @type {?} */
    FieldsMappingPair.prototype.LEFT_FIELD;
    /** @type {?} */
    FieldsMappingPair.prototype.RIGHT_FIELD;
}
class EntityRelation {
}
if (false) {
    /** @type {?} */
    EntityRelation.prototype.RELATION_ID;
    /** @type {?} */
    EntityRelation.prototype.RELATION_DESC;
    /** @type {?} */
    EntityRelation.prototype.CARDINALITY;
    /** @type {?} */
    EntityRelation.prototype.ROLE_ID;
    /** @type {?} */
    EntityRelation.prototype.CONDITIONAL_ATTR;
    /** @type {?} */
    EntityRelation.prototype.CONDITIONAL_VALUE;
    /** @type {?} */
    EntityRelation.prototype.EMPTY;
    /** @type {?} */
    EntityRelation.prototype.DISABLED;
    /** @type {?} */
    EntityRelation.prototype.ATTRIBUTES;
}
class Selection {
}
if (false) {
    /** @type {?} */
    Selection.prototype.RELATION_ID;
    /** @type {?} */
    Selection.prototype.FIELD_NAME;
    /** @type {?} */
    Selection.prototype.OPERATOR;
    /** @type {?} */
    Selection.prototype.LOW;
    /** @type {?} */
    Selection.prototype.HIGH;
}
class Projection {
}
if (false) {
    /** @type {?} */
    Projection.prototype.RELATION_ID;
    /** @type {?} */
    Projection.prototype.FIELD_NAME;
    /** @type {?} */
    Projection.prototype.ALIAS;
}
class QueryObject {
}
if (false) {
    /** @type {?} */
    QueryObject.prototype.ENTITY_ID;
    /** @type {?} */
    QueryObject.prototype.RELATION_ID;
    /** @type {?} */
    QueryObject.prototype.PROJECTION;
    /** @type {?} */
    QueryObject.prototype.FILTER;
    /** @type {?} */
    QueryObject.prototype.SORT;
}
class Sort {
}
if (false) {
    /** @type {?} */
    Sort.prototype.FIELD_NAME;
    /** @type {?} */
    Sort.prototype.RELATION_ID;
    /** @type {?} */
    Sort.prototype.ORDER;
}
class EntityType {
}
if (false) {
    /** @type {?} */
    EntityType.prototype.ENTITY_ID;
    /** @type {?} */
    EntityType.prototype.ENTITY_DESC;
    /** @type {?} */
    EntityType.prototype.VERSION_NO;
    /** @type {?} */
    EntityType.prototype.CREATE_BY;
    /** @type {?} */
    EntityType.prototype.CREATE_TIME;
    /** @type {?} */
    EntityType.prototype.LAST_CHANGE_BY;
    /** @type {?} */
    EntityType.prototype.LAST_CHANGE_TIME;
}
class Relation {
}
if (false) {
    /** @type {?} */
    Relation.prototype.RELATION_ID;
    /** @type {?} */
    Relation.prototype.RELATION_DESC;
    /** @type {?} */
    Relation.prototype.VERSION_NO;
    /** @type {?} */
    Relation.prototype.CREATE_BY;
    /** @type {?} */
    Relation.prototype.CREATE_TIME;
    /** @type {?} */
    Relation.prototype.LAST_CHANGE_BY;
    /** @type {?} */
    Relation.prototype.LAST_CHANGE_TIME;
}
class RelationshipH {
}
if (false) {
    /** @type {?} */
    RelationshipH.prototype.RELATIONSHIP_ID;
    /** @type {?} */
    RelationshipH.prototype.RELATIONSHIP_DESC;
    /** @type {?} */
    RelationshipH.prototype.VALID_PERIOD;
    /** @type {?} */
    RelationshipH.prototype.VERSION_NO;
    /** @type {?} */
    RelationshipH.prototype.CREATE_BY;
    /** @type {?} */
    RelationshipH.prototype.CREATE_TIME;
    /** @type {?} */
    RelationshipH.prototype.LAST_CHANGE_BY;
    /** @type {?} */
    RelationshipH.prototype.LAST_CHANGE_TIME;
}
class RoleH {
}
if (false) {
    /** @type {?} */
    RoleH.prototype.ROLE_ID;
    /** @type {?} */
    RoleH.prototype.ROLE_DESC;
    /** @type {?} */
    RoleH.prototype.VERSION_NO;
    /** @type {?} */
    RoleH.prototype.CREATE_BY;
    /** @type {?} */
    RoleH.prototype.CREATE_TIME;
    /** @type {?} */
    RoleH.prototype.LAST_CHANGE_BY;
    /** @type {?} */
    RoleH.prototype.LAST_CHANGE_TIME;
}
class RoleMeta {
}
if (false) {
    /** @type {?} */
    RoleMeta.prototype.ROLE_ID;
    /** @type {?} */
    RoleMeta.prototype.ROLE_DESC;
    /** @type {?} */
    RoleMeta.prototype.CREATE_BY;
    /** @type {?} */
    RoleMeta.prototype.CREATE_TIME;
    /** @type {?} */
    RoleMeta.prototype.LAST_CHANGE_BY;
    /** @type {?} */
    RoleMeta.prototype.LAST_CHANGE_TIME;
    /** @type {?} */
    RoleMeta.prototype.RELATIONS;
}
class DataElementH {
}
if (false) {
    /** @type {?} */
    DataElementH.prototype.ELEMENT_ID;
    /** @type {?} */
    DataElementH.prototype.ELEMENT_DESC;
    /** @type {?} */
    DataElementH.prototype.VERSION_NO;
    /** @type {?} */
    DataElementH.prototype.CREATE_BY;
    /** @type {?} */
    DataElementH.prototype.CREATE_TIME;
    /** @type {?} */
    DataElementH.prototype.LAST_CHANGE_BY;
    /** @type {?} */
    DataElementH.prototype.LAST_CHANGE_TIME;
}
class DataElementMeta {
}
if (false) {
    /** @type {?} */
    DataElementMeta.prototype.ELEMENT_ID;
    /** @type {?} */
    DataElementMeta.prototype.ELEMENT_DESC;
    /** @type {?} */
    DataElementMeta.prototype.LABEL_TEXT;
    /** @type {?} */
    DataElementMeta.prototype.LIST_HEADER_TEXT;
    /** @type {?} */
    DataElementMeta.prototype.DOMAIN_ID;
    /** @type {?} */
    DataElementMeta.prototype.DATA_TYPE;
    /** @type {?} */
    DataElementMeta.prototype.DATA_LENGTH;
    /** @type {?} */
    DataElementMeta.prototype.DECIMAL;
    /** @type {?} */
    DataElementMeta.prototype.SEARCH_HELP_ID;
    /** @type {?} */
    DataElementMeta.prototype.SEARCH_HELP_EXPORT_FIELD;
    /** @type {?} */
    DataElementMeta.prototype.PARAMETER_ID;
    /** @type {?} */
    DataElementMeta.prototype.VERSION_NO;
    /** @type {?} */
    DataElementMeta.prototype.CREATE_BY;
    /** @type {?} */
    DataElementMeta.prototype.CREATE_TIME;
    /** @type {?} */
    DataElementMeta.prototype.LAST_CHANGE_BY;
    /** @type {?} */
    DataElementMeta.prototype.LAST_CHANGE_TIME;
}
class DataDomainH {
}
if (false) {
    /** @type {?} */
    DataDomainH.prototype.DOMAIN_ID;
    /** @type {?} */
    DataDomainH.prototype.DOMAIN_DESC;
    /** @type {?} */
    DataDomainH.prototype.VERSION_NO;
    /** @type {?} */
    DataDomainH.prototype.CREATE_BY;
    /** @type {?} */
    DataDomainH.prototype.CREATE_TIME;
    /** @type {?} */
    DataDomainH.prototype.LAST_CHANGE_BY;
    /** @type {?} */
    DataDomainH.prototype.LAST_CHANGE_TIME;
}
class DataDomainMeta {
}
if (false) {
    /** @type {?} */
    DataDomainMeta.prototype.DOMAIN_ID;
    /** @type {?} */
    DataDomainMeta.prototype.DOMAIN_DESC;
    /** @type {?} */
    DataDomainMeta.prototype.DATA_TYPE;
    /** @type {?} */
    DataDomainMeta.prototype.DATA_LENGTH;
    /** @type {?} */
    DataDomainMeta.prototype.DOMAIN_TYPE;
    /** @type {?} */
    DataDomainMeta.prototype.DECIMAL;
    /** @type {?} */
    DataDomainMeta.prototype.UNSIGNED;
    /** @type {?} */
    DataDomainMeta.prototype.CAPITAL_ONLY;
    /** @type {?} */
    DataDomainMeta.prototype.REG_EXPR;
    /** @type {?} */
    DataDomainMeta.prototype.ENTITY_ID;
    /** @type {?} */
    DataDomainMeta.prototype.RELATION_ID;
    /** @type {?} */
    DataDomainMeta.prototype.DOMAIN_VALUES;
    /** @type {?} */
    DataDomainMeta.prototype.VERSION_NO;
    /** @type {?} */
    DataDomainMeta.prototype.CREATE_BY;
    /** @type {?} */
    DataDomainMeta.prototype.CREATE_TIME;
    /** @type {?} */
    DataDomainMeta.prototype.LAST_CHANGE_BY;
    /** @type {?} */
    DataDomainMeta.prototype.LAST_CHANGE_TIME;
}
class DataDomainValue {
}
if (false) {
    /** @type {?} */
    DataDomainValue.prototype.LOW_VALUE;
    /** @type {?} */
    DataDomainValue.prototype.LOW_VALUE_TEXT;
    /** @type {?} */
    DataDomainValue.prototype.HIGH_VALUE;
}
class SearchHelpH {
}
if (false) {
    /** @type {?} */
    SearchHelpH.prototype.SEARCH_HELP_ID;
    /** @type {?} */
    SearchHelpH.prototype.SEARCH_HELP_DESC;
    /** @type {?} */
    SearchHelpH.prototype.VERSION_NO;
    /** @type {?} */
    SearchHelpH.prototype.CREATE_BY;
    /** @type {?} */
    SearchHelpH.prototype.CREATE_TIME;
    /** @type {?} */
    SearchHelpH.prototype.LAST_CHANGE_BY;
    /** @type {?} */
    SearchHelpH.prototype.LAST_CHANGE_TIME;
}
class SearchHelpMeta {
}
if (false) {
    /** @type {?} */
    SearchHelpMeta.prototype.SEARCH_HELP_ID;
    /** @type {?} */
    SearchHelpMeta.prototype.SEARCH_HELP_DESC;
    /** @type {?} */
    SearchHelpMeta.prototype.VERSION_NO;
    /** @type {?} */
    SearchHelpMeta.prototype.BEHAVIOUR;
    /** @type {?} */
    SearchHelpMeta.prototype.ENTITY_ID;
    /** @type {?} */
    SearchHelpMeta.prototype.RELATION_ID;
    /** @type {?} */
    SearchHelpMeta.prototype.MULTI;
    /** @type {?} */
    SearchHelpMeta.prototype.FUZZY_SEARCH;
    /** @type {?} */
    SearchHelpMeta.prototype.FIELDS;
    /** @type {?} */
    SearchHelpMeta.prototype.CREATE_BY;
    /** @type {?} */
    SearchHelpMeta.prototype.CREATE_TIME;
    /** @type {?} */
    SearchHelpMeta.prototype.LAST_CHANGE_BY;
    /** @type {?} */
    SearchHelpMeta.prototype.LAST_CHANGE_TIME;
}
class SearchHelpFieldMeta {
}
if (false) {
    /** @type {?} */
    SearchHelpFieldMeta.prototype.RELATION_ID;
    /** @type {?} */
    SearchHelpFieldMeta.prototype.FIELD_NAME;
    /** @type {?} */
    SearchHelpFieldMeta.prototype.FIELD_DESC;
    /** @type {?} */
    SearchHelpFieldMeta.prototype.LABEL_TEXT;
    /** @type {?} */
    SearchHelpFieldMeta.prototype.LIST_HEADER_TEST;
    /** @type {?} */
    SearchHelpFieldMeta.prototype.IMPORT;
    /** @type {?} */
    SearchHelpFieldMeta.prototype.EXPORT;
    /** @type {?} */
    SearchHelpFieldMeta.prototype.IE_FIELD_NAME;
    /** @type {?} */
    SearchHelpFieldMeta.prototype.LIST_POSITION;
    /** @type {?} */
    SearchHelpFieldMeta.prototype.FILTER_POSITION;
    /** @type {?} */
    SearchHelpFieldMeta.prototype.FILTER_DISP_ONLY;
    /** @type {?} */
    SearchHelpFieldMeta.prototype.DEFAULT_VALUE;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ui-mapper.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UiMapperService {
    constructor() { }
    /**
     * Map a FormGroup to a JOR relation(with cardinality [0..1] and [1..1]) for adding or updating.
     * @param {?} formGroup
     * @param {?} keys
     * @param {?=} isNew
     * @return {?}
     */
    composeChangedRelation(formGroup, keys, isNew = true) {
        if (!formGroup.dirty || !keys || Object.keys(keys).length === 0) {
            return {};
        }
        /** @type {?} */
        const changedRelation = { action: isNew ? 'add' : 'update' };
        Object.keys(keys).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => changedRelation[key] = keys[key] || formGroup.value[key]));
        Object.keys(formGroup.controls).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => {
            /** @type {?} */
            const control = formGroup.get(key);
            if (control.dirty) {
                changedRelation[key] = control.value;
            }
        }));
        return changedRelation;
    }
    /**
     * Map a FormArray to JOR relation(with cardinality [0..n] or [1..n]) for adding, updating, or deletion.
     * @param {?} formArray
     * @param {?} originalArray
     * @param {?} keys
     * @return {?}
     */
    composeChangedRelationArray(formArray, originalArray, keys) {
        if (!formArray.dirty || !keys || Object.keys(keys).length === 0) {
            return [];
        }
        if (!originalArray) {
            originalArray = [];
        }
        /** @type {?} */
        const changedRelationArray = [];
        formArray.controls.forEach((/**
         * @param {?} formGroup
         * @return {?}
         */
        formGroup => {
            if (formGroup.dirty) {
                /** @type {?} */
                const changedRelation = {};
                changedRelationArray.push(changedRelation);
                /** @type {?} */
                const index = originalArray.findIndex((/**
                 * @param {?} element
                 * @return {?}
                 */
                element => {
                    /** @type {?} */
                    let found = true;
                    Object.keys(keys).forEach((/**
                     * @param {?} key
                     * @return {?}
                     */
                    key => {
                        if (keys[key]) {
                            return;
                        }
                        found = found && (element[key] === formGroup.value[key]);
                    }));
                    return found;
                }));
                changedRelation['action'] = index === -1 ? 'add' : 'update';
                Object.keys(keys).forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                key => changedRelation[key] = keys[key] || formGroup.value[key]));
                Object.keys(formGroup['controls']).forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                key => {
                    /** @type {?} */
                    const control = formGroup.get(key);
                    if (control.dirty) {
                        changedRelation[key] = control.value;
                    }
                }));
            }
        }));
        originalArray.forEach((/**
         * @param {?} originalRelation
         * @return {?}
         */
        originalRelation => {
            /** @type {?} */
            const index = formArray.controls.findIndex((/**
             * @param {?} element
             * @return {?}
             */
            element => {
                /** @type {?} */
                let found = true;
                Object.keys(keys).forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                key => {
                    if (keys[key]) {
                        return;
                    }
                    found = found && (element.value[key] === originalRelation[key]);
                }));
                return found;
            }));
            if (index === -1) {
                /** @type {?} */
                const deletedRelation = { action: 'delete' };
                Object.keys(keys).forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                key => deletedRelation[key] = keys[key] || originalRelation[key]));
                changedRelationArray.push(deletedRelation);
            }
        }));
        return changedRelationArray;
    }
    /**
     * Map a FormArray to JOR relationships for adding, updating, or deletion.
     * @param {?} relationshipID
     * @param {?} partnerRoles
     * @param {?} formArray
     * @param {?} originalArray
     * @param {?} nonRelationshipAttributes
     * @return {?}
     */
    composeChangedRelationship(relationshipID, partnerRoles, formArray, originalArray, nonRelationshipAttributes) {
        if (!formArray.dirty) {
            return null;
        }
        /** @type {?} */
        const relationship = {
            RELATIONSHIP_ID: relationshipID,
            values: []
        };
        formArray.controls.forEach((/**
         * @param {?} formGroup
         * @return {?}
         */
        formGroup => {
            if (formGroup.dirty) {
                /** @type {?} */
                const changedRelationshipValue = {};
                relationship.values.push(changedRelationshipValue);
                if (formGroup.value['RELATIONSHIP_INSTANCE_GUID']) {
                    changedRelationshipValue['action'] = 'update';
                    changedRelationshipValue['RELATIONSHIP_INSTANCE_GUID'] = formGroup.value['RELATIONSHIP_INSTANCE_GUID'];
                }
                else {
                    changedRelationshipValue['action'] = 'add';
                    changedRelationshipValue['PARTNER_INSTANCES'] = [];
                    partnerRoles.forEach((/**
                     * @param {?} partnerRole
                     * @return {?}
                     */
                    partnerRole => changedRelationshipValue['PARTNER_INSTANCES'].push({
                        ENTITY_ID: partnerRole.ENTITY_ID,
                        ROLE_ID: partnerRole.ROLE_ID,
                        INSTANCE_GUID: formGroup.value[partnerRole.ROLE_ID + '_INSTANCE_GUID']
                    })));
                }
                Object.keys(formGroup['controls']).forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                key => {
                    if (nonRelationshipAttributes.includes(key) || key.substr(-13) === 'INSTANCE_GUID') {
                        return;
                    }
                    /** @type {?} */
                    const control = formGroup.get(key);
                    if (control.dirty) {
                        changedRelationshipValue[key] = control.value;
                    }
                }));
            }
        }));
        originalArray.forEach((/**
         * @param {?} original
         * @return {?}
         */
        original => {
            if (formArray.controls.findIndex((/**
             * @param {?} formGroup
             * @return {?}
             */
            formGroup => formGroup.value['RELATIONSHIP_INSTANCE_GUID'] === original['RELATIONSHIP_INSTANCE_GUID'])) === -1) {
                relationship.values.push({ action: 'delete', RELATIONSHIP_INSTANCE_GUID: original['RELATIONSHIP_INSTANCE_GUID'] });
            }
        }));
        return relationship.values.length === 0 ? null : relationship;
    }
}
UiMapperService.ɵfac = function UiMapperService_Factory(t) { return new (t || UiMapperService)(); };
/** @nocollapse */
UiMapperService.ctorParameters = () => [];
/** @nocollapse */ UiMapperService.ɵprov = ɵɵdefineInjectable({ factory: function UiMapperService_Factory() { return new UiMapperService(); }, token: UiMapperService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UiMapperService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/entity.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
class EntityService {
    /**
     * @param {?} http
     * @param {?} messageService
     */
    constructor(http, messageService) {
        this.http = http;
        this.messageService = messageService;
        this.originalHost = '';
        this.fakeUUIDs = [];
        this.messageService.setMessageStore([
            { msgCat: 'EXCEPTION', msgName: 'GENERIC',
                msgText: { EN: { shortText: 'Exception Occurs in Operation: %s', longText: '%s2' } } },
            { msgCat: 'EXCEPTION', msgName: 'SESSION_EXPIRED',
                msgText: { EN: { shortText: 'Your session is expired',
                        longText: 'Your session is expired, please <a href="/logon">re-logon</a>' } } }
        ], 'EN');
    }
    /**
     * @param {?} host
     * @return {?}
     */
    setOriginalHost(host) {
        this.originalHost = host;
    }
    /**
     * @param {?} msgStore
     * @param {?} language
     * @return {?}
     */
    setMessageStore(msgStore, language) {
        this.messageService.setMessageStore(msgStore, language);
    }
    /**
     * List all entity IDs in the system
     * @return {?}
     */
    listEntityID() {
        return this.http.get(this.originalHost + `/api/entity/EntityIDs`).pipe(catchError(this.handleError('listEntityID')));
    }
    /**
     * List entity IDs by a given role ID
     * @param {?} roleID
     * @return {?}
     */
    listEntityIDbyRole(roleID) {
        return this.http.get(this.originalHost + `/api/entity/EntityIDs/${roleID}`).pipe(catchError(this.handleError('listEntityIDbyRole')));
    }
    /**
     * Return the entity meta for a given entity ID
     * @param {?} entityID
     * @return {?}
     */
    getEntityMeta(entityID) {
        return this.http.get(this.originalHost + `/api/entity/meta/${entityID}`).pipe(catchError(this.handleError('getEntityMeta')));
    }
    /**
     * Return a list of entity objects according to the description of a given query object
     * @param {?} queryObject
     * @return {?}
     */
    searchEntities(queryObject) {
        return this.http.post(this.originalHost + `/api/query`, queryObject, httpOptions).pipe(catchError(this.handleError('searchEntities')));
    }
    /**
     * Return an entity instance for a given entity instance GUID
     * @param {?} instanceGUID
     * @return {?}
     */
    getEntityInstance(instanceGUID) {
        return this.http.get(this.originalHost + `/api/entity/instance/${instanceGUID}`).pipe(catchError(this.handleError('getEntityInstance')));
    }
    /**
     * Return a relation's meta data for a given relation ID
     * @param {?} relationID
     * @return {?}
     */
    getRelationMeta(relationID) {
        return this.http.get(this.originalHost + `/api/relation/meta/${relationID}`).pipe(catchError(this.handleError('getRelationMeta')));
    }
    /**
     * Return all relations' meta data for a given entity ID
     * @param {?} entityID
     * @return {?}
     */
    getRelationMetaOfEntity(entityID) {
        return this.http.get(this.originalHost + `/api/relation/meta/entity/${entityID}`).pipe(catchError(this.handleError('getRelationMetaOfEntity')));
    }
    /**
     * Create a new entity instance
     * @param {?} instance
     * @return {?}
     */
    createEntityInstance(instance) {
        return this.http.post(this.originalHost + `/api/entity`, instance, httpOptions).pipe(catchError(this.handleError('createEntityInstance')));
    }
    /**
     * Change an existing entity instance
     * @param {?} instance
     * @return {?}
     */
    changeEntityInstance(instance) {
        return this.http.put(this.originalHost + `/api/entity`, instance, httpOptions).pipe(catchError(this.handleError('changeEntityInstance')));
    }
    /**
     * Delete an entity instance from a given instance GUID
     * @param {?} instanceGUID
     * @return {?}
     */
    deleteEntityInstance(instanceGUID) {
        return this.http.delete(this.originalHost + `/api/entity/instance/${instanceGUID}`).pipe(catchError(this.handleError('deleteEntityInstance')));
    }
    /**
     * Return entity types(IDs) for a given search term
     * @param {?} term
     * @return {?}
     */
    listEntityType(term) {
        return this.http.get(this.originalHost + `/api/model/entity-types?term=${term}`).pipe(catchError(this.handleError('listEntityType')));
    }
    /**
     * Return the description of a given entity type(ID)
     * @param {?} entityID
     * @return {?}
     */
    getEntityTypeDesc(entityID) {
        return this.http.get(this.originalHost + `/api/model/entity-types/${entityID}/desc`).pipe(catchError(this.handleError('getEntityTypeDesc')));
    }
    /**
     * Save an entity type after changing or creation
     * @param {?} entityType
     * @return {?}
     */
    saveEntityType(entityType) {
        return this.http.post(this.originalHost + `/api/model/entity-types`, entityType, httpOptions).pipe(catchError(this.handleError('saveEntityType')));
    }
    /**
     * Return a list of relations in the system according to the search term
     * @param {?} term
     * @return {?}
     */
    listRelation(term) {
        return this.http.get(this.originalHost + `/api/model/relations?term=${term}`).pipe(catchError(this.handleError('listRelation')));
    }
    /**
     * Return the description of a given relation ID
     * @param {?} relationID
     * @return {?}
     */
    getRelationDesc(relationID) {
        return this.http.get(this.originalHost + `/api/model/relations/${relationID}/desc`).pipe(catchError(this.handleError('getRelationDesc')));
    }
    /**
     * Save a relation after changing or creation
     * @param {?} relation
     * @return {?}
     */
    saveRelation(relation) {
        return this.http.post(this.originalHost + `/api/model/relations`, relation, httpOptions).pipe(catchError(this.handleError('saveRelation')));
    }
    /**
     * Return a list of relationships in the system according to the search term
     * @param {?} term
     * @return {?}
     */
    listRelationship(term) {
        return this.http.get(this.originalHost + `/api/model/relationships?term=${term}`).pipe(catchError(this.handleError('listRelationship')));
    }
    /**
     * Return a relationship definition from a given relationship ID
     * @param {?} relationshipID
     * @return {?}
     */
    getRelationship(relationshipID) {
        return this.http.get(this.originalHost + `/api/model/relationships/${relationshipID}`).pipe(catchError(this.handleError('getRelationship')));
    }
    /**
     * Return the description of a given relationship ID
     * @param {?} relationshipID
     * @return {?}
     */
    getRelationshipDesc(relationshipID) {
        return this.http.get(this.originalHost + `/api/model/relationships/${relationshipID}/desc`).pipe(catchError(this.handleError('getRelationshipDesc')));
    }
    /**
     * Save a relationship after changing or creation
     * @param {?} relationship
     * @return {?}
     */
    saveRelationship(relationship) {
        return this.http.post(this.originalHost + `/api/model/relationships`, relationship, httpOptions).pipe(catchError(this.handleError('saveRelationship')));
    }
    /**
     * Return a list of roles in the system according to the search term
     * @param {?} term
     * @return {?}
     */
    listRole(term) {
        return this.http.get(this.originalHost + `/api/model/roles?term=${term}`).pipe(catchError(this.handleError('listRole')));
    }
    /**
     * Return a role definition from a given role ID
     * @param {?} roleID
     * @return {?}
     */
    getRole(roleID) {
        return this.http.get(this.originalHost + `/api/model/roles/${roleID}`).pipe(catchError(this.handleError('getRole')));
    }
    /**
     * Return the description of a given role ID
     * @param {?} roleID
     * @return {?}
     */
    getRoleDesc(roleID) {
        return this.http.get(this.originalHost + `/api/model/roles/${roleID}/desc`).pipe(catchError(this.handleError('getRoleDesc')));
    }
    /**
     * Save a role after changing or creation
     * @param {?} role
     * @return {?}
     */
    saveRole(role) {
        return this.http.post(this.originalHost + `/api/model/roles`, role, httpOptions).pipe(catchError(this.handleError('saveRole')));
    }
    /**
     * Return a list of data elements in the system according to the search term
     * @param {?} term
     * @return {?}
     */
    listDataElement(term) {
        return this.http.get(this.originalHost + `/api/model/data-elements?term=${term}`).pipe(catchError(this.handleError('listDataElement')));
    }
    /**
     * Return a data element definition from a given element ID
     * @param {?} elementID
     * @return {?}
     */
    getDataElement(elementID) {
        return this.http.get(this.originalHost + `/api/model/data-elements/${elementID}`).pipe(catchError(this.handleError('getDataElement')));
    }
    /**
     * Return the description of a given data element ID
     * @param {?} elementID
     * @return {?}
     */
    getDataElementDesc(elementID) {
        return this.http.get(this.originalHost + `/api/model/data-elements/${elementID}/desc`).pipe(catchError(this.handleError('getDataElementDesc')));
    }
    /**
     * Save a data element after changing or creation
     * @param {?} element
     * @return {?}
     */
    saveDataElement(element) {
        return this.http.post(this.originalHost + `/api/model/data-elements`, element, httpOptions).pipe(catchError(this.handleError('saveDataElement')));
    }
    /**
     * Return a list of data domains in the system according to the search term
     * @param {?} term
     * @return {?}
     */
    listDataDomain(term) {
        return this.http.get(this.originalHost + `/api/model/data-domains?term=${term}`).pipe(catchError(this.handleError('listDataDomain')));
    }
    /**
     * Return a data domain definition from a given domain ID
     * @param {?} domainID
     * @return {?}
     */
    getDataDomain(domainID) {
        return this.http.get(this.originalHost + `/api/model/data-domains/${domainID}`).pipe(catchError(this.handleError('getDataDomain')));
    }
    /**
     * Return the description of a given data domain ID
     * @param {?} domainID
     * @return {?}
     */
    getDataDomainDesc(domainID) {
        return this.http.get(this.originalHost + `/api/model/data-domains/${domainID}/desc`).pipe(catchError(this.handleError('getDataDomainDesc')));
    }
    /**
     * Save a data domain after changing or creation
     * @param {?} domain
     * @return {?}
     */
    saveDataDomain(domain) {
        return this.http.post(this.originalHost + `/api/model/data-domains`, domain, httpOptions).pipe(catchError(this.handleError('saveDataDomain')));
    }
    /**
     * Return a list of search helps in the system according to the search term
     * @param {?} term
     * @return {?}
     */
    listSearchHelp(term) {
        return this.http.get(this.originalHost + `/api/model/search-helps?term=${term}`).pipe(catchError(this.handleError('listSearchHelp')));
    }
    /**
     * Return a search help definition from a given domain ID
     * @param {?} searchHelpID
     * @return {?}
     */
    getSearchHelp(searchHelpID) {
        return this.http.get(this.originalHost + `/api/model/search-helps/${searchHelpID}`).pipe(catchError(this.handleError('getSearchHelp')));
    }
    /**
     * Return the description of a given search help ID
     * @param {?} searchHelpID
     * @return {?}
     */
    getSearchHelpDesc(searchHelpID) {
        return this.http.get(this.originalHost + `/api/model/search-helps/${searchHelpID}/desc`).pipe(catchError(this.handleError('getSearchHelpDesc')));
    }
    /**
     * Save a search help after changing or creation
     * @param {?} searchHelp
     * @return {?}
     */
    saveSearchHelp(searchHelp) {
        return this.http.post(this.originalHost + `/api/model/search-helps`, searchHelp, httpOptions).pipe(catchError(this.handleError('saveSearchHelp')));
    }
    /**
     * Get data element meta
     * @param {?} elementID
     * @return {?}
     */
    getElementMeta(elementID) {
        return this.http.get(this.originalHost + `/api/model/element-meta/${elementID}`).pipe(catchError(this.handleError('getElementMeta')));
    }
    /**
     * Return a fake relationship ID before saving
     * @return {?}
     */
    generateFakeRelationshipUUID() {
        /** @type {?} */
        const nextPosition = this.fakeUUIDs.length + 1;
        /** @type {?} */
        const fakeUUID = 'NewRelationship_' + nextPosition;
        this.fakeUUIDs.push(fakeUUID);
        return fakeUUID;
    }
    /**
     * @private
     * @template T
     * @param {?=} operation
     * @param {?=} result
     * @return {?}
     */
    handleError(operation = 'operation', result) {
        return (/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            if (error.status === 401) {
                this.messageService.addMessage('EXCEPTION', 'SESSION_EXPIRED', messageType.Exception);
            }
            else {
                this.messageService.addMessage('EXCEPTION', 'GENERIC', messageType.Exception, operation, error.message);
            }
            // Let the app keep running by returning an empty result.
            return of((/** @type {?} */ (result)));
        });
    }
}
EntityService.ɵfac = function EntityService_Factory(t) { return new (t || EntityService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.MessageService)); };
/** @nocollapse */
EntityService.ctorParameters = () => [
    { type: HttpClient },
    { type: MessageService }
];
/** @nocollapse */ EntityService.ɵprov = ɵɵdefineInjectable({ factory: function EntityService_Factory() { return new EntityService(ɵɵinject(HttpClient), ɵɵinject(MessageService)); }, token: EntityService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.MessageService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    EntityService.prototype.originalHost;
    /**
     * @type {?}
     * @private
     */
    EntityService.prototype.fakeUUIDs;
    /**
     * @type {?}
     * @private
     */
    EntityService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    EntityService.prototype.messageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/search-help/search-help.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SearchHelp {
}
if (false) {
    /** @type {?} */
    SearchHelp.prototype.OBJECT_NAME;
    /** @type {?} */
    SearchHelp.prototype.METHOD;
    /** @type {?} */
    SearchHelp.prototype.BEHAVIOUR;
    /** @type {?} */
    SearchHelp.prototype.MULTI;
    /** @type {?} */
    SearchHelp.prototype.FUZZY_SEARCH;
    /** @type {?} */
    SearchHelp.prototype.READ_ONLY;
    /** @type {?} */
    SearchHelp.prototype.ENTITY_ID;
    /** @type {?} */
    SearchHelp.prototype.RELATION_ID;
    /** @type {?} */
    SearchHelp.prototype.FIELDS;
}
class SearchHelpField {
}
if (false) {
    /** @type {?} */
    SearchHelpField.prototype.RELATION_ID;
    /** @type {?} */
    SearchHelpField.prototype.FIELD_NAME;
    /** @type {?} */
    SearchHelpField.prototype.LABEL_TEXT;
    /** @type {?} */
    SearchHelpField.prototype.LIST_HEADER_TEXT;
    /** @type {?} */
    SearchHelpField.prototype.IMPORT;
    /** @type {?} */
    SearchHelpField.prototype.EXPORT;
    /** @type {?} */
    SearchHelpField.prototype.IE_FIELD_NAME;
    /** @type {?} */
    SearchHelpField.prototype.LIST_POSITION;
    /** @type {?} */
    SearchHelpField.prototype.FILTER_POSITION;
    /** @type {?} */
    SearchHelpField.prototype.FILTER_DISP_ONLY;
    /** @type {?} */
    SearchHelpField.prototype.DEFAULT_VALUE;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/search-help/search-help.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SearchHelpComponent {
    /**
     * @param {?} fb
     * @param {?} entityService
     */
    constructor(fb, entityService) {
        this.fb = fb;
        this.entityService = entityService;
        this.isSearchHelpModalShown = false;
        this.isFilterShown = false;
        this.isSelectAllChecked = false;
        this.selectedIndex = -1;
        this.filterFields = [];
        this.listFields = [];
        this.listData = [];
        this.preSearchHelpParas = {};
    }
    /**
     * @return {?}
     */
    get displaySearchHelpModal() { return this.isSearchHelpModalShown ? 'block' : 'none'; }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.filterFieldsFormGroup = this.fb.group({});
    }
    /**
     * Open an search help dialog with free style
     * @param {?} searchHelp
     * @param {?} exportControl
     * @param {?=} afterExportFn
     * @return {?}
     */
    openSearchHelpModal(searchHelp, exportControl, afterExportFn) {
        if (this.searchHelp !== searchHelp) {
            this.listData = [];
            this.searchHelp = searchHelp;
            this.filterFieldsFormGroup = this.fb.group({});
            this.filterFields = this.searchHelp.FIELDS.filter((/**
             * @param {?} fieldMeta
             * @return {?}
             */
            fieldMeta => fieldMeta.FILTER_POSITION));
            this.filterFields.sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            (a, b) => a.FILTER_POSITION - b.FILTER_POSITION));
            this.filterFields.forEach((/**
             * @param {?} fieldMeta
             * @return {?}
             */
            fieldMeta => {
                if (fieldMeta.IMPORT) {
                    /** @type {?} */
                    const ieFieldName = fieldMeta.IE_FIELD_NAME || fieldMeta.FIELD_NAME;
                    if (exportControl.get(ieFieldName)) {
                        fieldMeta.DEFAULT_VALUE = exportControl.get(ieFieldName).value;
                    }
                }
                this.filterFieldsFormGroup.addControl(fieldMeta.FIELD_NAME, this.fb.control(fieldMeta.DEFAULT_VALUE));
            }));
            this.listFields = this.searchHelp.FIELDS.filter((/**
             * @param {?} fieldMeta
             * @return {?}
             */
            fieldMeta => fieldMeta.LIST_POSITION));
            this.listFields.sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            (a, b) => a.LIST_POSITION - b.LIST_POSITION));
        }
        // Import the value to fuzzy search field
        if (this.searchHelp.FUZZY_SEARCH) {
            this.fuzzySearchTerm = '';
            this.searchHelp.FIELDS.forEach((/**
             * @param {?} fieldMeta
             * @return {?}
             */
            fieldMeta => {
                /** @type {?} */
                const ieFieldName = fieldMeta.IE_FIELD_NAME || fieldMeta.FIELD_NAME;
                /** @type {?} */
                const ctrl = exportControl.get(ieFieldName);
                if (!this.fuzzySearchTerm && ctrl && ctrl.value) {
                    this.fuzzySearchTerm = ctrl.value;
                    return;
                }
            }));
        }
        this.exportControl = exportControl;
        this.afterExportFn = afterExportFn;
        if (this.searchHelp.BEHAVIOUR === 'A') {
            this.search();
            this.isFilterShown = false;
        }
        else {
            this.isFilterShown = true;
        }
        this.isSearchHelpModalShown = true;
    }
    /**
     * Open a search help dialog based on the given entity and one of its relation
     * @param {?} entityID
     * @param {?} relationID
     * @param {?} exportControl
     * @param {?} readonly
     * @param {?=} exportField
     * @param {?=} domainID
     * @param {?=} afterExportFn
     * @return {?}
     */
    openSearchHelpModalByEntity(entityID, relationID, exportControl, readonly, exportField, domainID, afterExportFn) {
        /** @type {?} */
        const currentSearchHelpParas = {
            'entityID': entityID,
            'relationID': relationID,
            'exportField': exportField,
            'domainID': domainID
        };
        if (this._isPreviousSearchHelp(currentSearchHelpParas)) {
            this.searchHelp.READ_ONLY = readonly;
            this.openSearchHelpModal(this.searchHelp, exportControl, afterExportFn);
        }
        else {
            this.listData = [];
            this.preSearchHelpParas = currentSearchHelpParas;
            /** @type {?} */
            const searchHelp = new SearchHelp();
            searchHelp.OBJECT_NAME = entityID;
            searchHelp.METHOD = (/**
             * @param {?} entityService
             * @return {?}
             */
            function (entityService) {
                return (/**
                 * @param {?} searchTerm
                 * @return {?}
                 */
                (searchTerm) => entityService.searchEntities(searchTerm));
            })(this.entityService);
            searchHelp.BEHAVIOUR = 'M';
            searchHelp.MULTI = false;
            searchHelp.FUZZY_SEARCH = false;
            searchHelp.FIELDS = [];
            searchHelp.READ_ONLY = readonly;
            searchHelp.ENTITY_ID = entityID;
            searchHelp.RELATION_ID = relationID;
            this.entityService.getRelationMeta(relationID)
                .subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                /** @type {?} */
                const relationMeta = (/** @type {?} */ (data));
                relationMeta.ATTRIBUTES.forEach((/**
                 * @param {?} attribute
                 * @return {?}
                 */
                attribute => searchHelp.FIELDS.push({
                    FIELD_NAME: attribute.ATTR_NAME,
                    LABEL_TEXT: attribute.LABEL_TEXT,
                    LIST_HEADER_TEXT: attribute.LIST_HEADER_TEXT,
                    IE_FIELD_NAME: exportField && domainID && domainID === attribute.DOMAIN_ID ? exportField : null,
                    IMPORT: attribute.PRIMARY_KEY || attribute.DOMAIN_ID === domainID,
                    EXPORT: attribute.PRIMARY_KEY || attribute.DOMAIN_ID === domainID,
                    LIST_POSITION: attribute.ORDER,
                    FILTER_POSITION: attribute.ORDER
                })));
                searchHelp.FIELDS.push({
                    FIELD_NAME: 'INSTANCE_GUID',
                    LIST_HEADER_TEXT: 'GUID',
                    IMPORT: false,
                    EXPORT: true,
                    LIST_POSITION: 999,
                    FILTER_POSITION: 0
                });
                this.openSearchHelpModal(searchHelp, exportControl, afterExportFn);
            }));
        }
    }
    /**
     * Open a search help dialog based on the given search help
     * @param {?} searchHelpID
     * @param {?} searchHelpExportField
     * @param {?} exportField
     * @param {?} exportControl
     * @param {?} readonly
     * @param {?=} afterExportFn
     * @return {?}
     */
    openSearchHelpModalBySearchHelp(searchHelpID, searchHelpExportField, exportField, exportControl, readonly, afterExportFn) {
        /** @type {?} */
        const currentSearchHelpParas = {
            'searchHelpID': searchHelpID,
            'searchHelpExportField': searchHelpExportField,
            'exportField': exportField
        };
        if (this._isPreviousSearchHelp(currentSearchHelpParas)) {
            this.searchHelp.READ_ONLY = readonly;
            this.openSearchHelpModal(this.searchHelp, exportControl, afterExportFn);
        }
        else {
            this.listData = [];
            this.preSearchHelpParas = currentSearchHelpParas;
            /** @type {?} */
            const searchHelp = new SearchHelp();
            this.entityService.getSearchHelp(searchHelpID)
                .subscribe((/**
             * @param {?} searchHelpMeta
             * @return {?}
             */
            (searchHelpMeta) => {
                searchHelp.OBJECT_NAME = searchHelpMeta.SEARCH_HELP_DESC + '(' + searchHelpMeta.SEARCH_HELP_ID + ')';
                searchHelp.METHOD = (/**
                 * @param {?} entityService
                 * @return {?}
                 */
                function (entityService) {
                    return (/**
                     * @param {?} searchTerm
                     * @return {?}
                     */
                    (searchTerm) => entityService.searchEntities(searchTerm));
                })(this.entityService);
                searchHelp.BEHAVIOUR = searchHelpMeta.BEHAVIOUR;
                searchHelp.MULTI = searchHelpMeta.MULTI;
                searchHelp.FUZZY_SEARCH = searchHelpMeta.FUZZY_SEARCH;
                searchHelp.READ_ONLY = readonly;
                searchHelp.ENTITY_ID = searchHelpMeta.ENTITY_ID;
                searchHelp.RELATION_ID = searchHelpMeta.RELATION_ID;
                searchHelp.FIELDS = searchHelpMeta.FIELDS;
                /** @type {?} */
                const searchHelpField = searchHelp.FIELDS.find((/**
                 * @param {?} field
                 * @return {?}
                 */
                field => (field.IE_FIELD_NAME || field.FIELD_NAME) === searchHelpExportField));
                searchHelpField.IE_FIELD_NAME = exportField;
                searchHelpField.EXPORT = true;
                searchHelpField.IMPORT = true;
                searchHelp.FIELDS.push({
                    FIELD_NAME: 'INSTANCE_GUID',
                    LIST_HEADER_TEXT: 'GUID',
                    IMPORT: false,
                    EXPORT: true,
                    LIST_POSITION: 999,
                    FILTER_POSITION: 0
                });
                this.openSearchHelpModal(searchHelp, exportControl, afterExportFn);
            }));
        }
    }
    /**
     * @param {?} currentSearchHelpParas
     * @return {?}
     */
    _isPreviousSearchHelp(currentSearchHelpParas) {
        return JSON.stringify(this.preSearchHelpParas) === JSON.stringify(currentSearchHelpParas);
    }
    /**
     * @return {?}
     */
    search() {
        /** @type {?} */
        let searchTerm;
        if (this.searchHelp.FUZZY_SEARCH) {
            searchTerm = this.fuzzySearchTerm || '';
        }
        else {
            searchTerm = new QueryObject();
            searchTerm.ENTITY_ID = this.searchHelp.ENTITY_ID;
            searchTerm.RELATION_ID = this.searchHelp.RELATION_ID;
            searchTerm.FILTER = [];
            this.filterFields.forEach((/**
             * @param {?} fieldMeta
             * @return {?}
             */
            fieldMeta => {
                /** @type {?} */
                const fieldValue = this.filterFieldsFormGroup.get(fieldMeta.FIELD_NAME).value;
                if (fieldValue) {
                    if (fieldValue.includes('*') || fieldValue.includes('%')) {
                        searchTerm.FILTER.push({ RELATION_ID: fieldMeta.RELATION_ID,
                            FIELD_NAME: fieldMeta.FIELD_NAME, OPERATOR: 'CN', LOW: fieldValue });
                    }
                    else {
                        searchTerm.FILTER.push({ RELATION_ID: fieldMeta.RELATION_ID,
                            FIELD_NAME: fieldMeta.FIELD_NAME, OPERATOR: 'EQ', LOW: fieldValue });
                    }
                }
            }));
            searchTerm.PROJECTION = [];
            this.listFields.forEach((/**
             * @param {?} fieldMeta
             * @return {?}
             */
            fieldMeta => {
                searchTerm.PROJECTION.push({ RELATION_ID: fieldMeta.RELATION_ID, FIELD_NAME: fieldMeta.FIELD_NAME });
            }));
        }
        this.listData = [];
        this.isSelectAllChecked = false;
        if (typeof this.searchHelp.METHOD === 'function') {
            /** @type {?} */
            const searchHelpMethod = (/** @type {?} */ (this.searchHelp.METHOD));
            searchHelpMethod(searchTerm).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => this._generateSearchList(data)));
        }
        else if (Array.isArray(this.searchHelp.METHOD)) {
            this._generateSearchList(this.searchHelp.METHOD);
        }
    }
    /**
     * @param {?} data
     * @return {?}
     */
    _generateSearchList(data) {
        data.forEach((/**
         * @param {?} item
         * @return {?}
         */
        item => {
            /** @type {?} */
            const listItem = { SELECTED: '' };
            this.listFields.forEach((/**
             * @param {?} field
             * @return {?}
             */
            field => listItem[field.FIELD_NAME] = item[field.FIELD_NAME]));
            this.listData.push(listItem);
        }));
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    enterSearch($event) {
        if ($event.keyCode === 13) {
            this.search();
        }
    }
    /**
     * @return {?}
     */
    showFilter() {
        this.isFilterShown = true;
    }
    /**
     * @return {?}
     */
    hideFilter() {
        this.isFilterShown = false;
    }
    /**
     * @return {?}
     */
    selectAll() {
        this.isSelectAllChecked = !this.isSelectAllChecked;
        this.listData.forEach((/**
         * @param {?} data
         * @return {?}
         */
        data => data.SELECTED = !data.SELECTED));
    }
    /**
     * @return {?}
     */
    confirmSelection() {
        // TODO: Currently, only single selection is supported. Multiple selection in later time
        if (this.searchHelp.READ_ONLY) {
            return;
        }
        this.listFields.forEach((/**
         * @param {?} listField
         * @return {?}
         */
        listField => {
            if (this.exportControl instanceof FormGroup) {
                /** @type {?} */
                const exportControl = (/** @type {?} */ (this.exportControl));
                /** @type {?} */
                const ieFieldName = listField.IE_FIELD_NAME || listField.FIELD_NAME;
                /** @type {?} */
                const exportFieldControl = exportControl.get(ieFieldName);
                if (listField.EXPORT && exportFieldControl) {
                    exportFieldControl.setValue(this.listData[this.selectedIndex][listField.FIELD_NAME]);
                    exportFieldControl.markAsDirty();
                }
            }
            else {
                if (listField.EXPORT) {
                    this.exportControl[listField.FIELD_NAME] = this.listData[this.selectedIndex][listField.FIELD_NAME];
                }
            }
        }));
        if (this.afterExportFn) {
            this.afterExportFn();
        }
        this.listData = [];
        this.isSearchHelpModalShown = false;
    }
    /**
     * @return {?}
     */
    closeSearchHelpModal() {
        this.isSearchHelpModalShown = false;
    }
}
SearchHelpComponent.ɵfac = function SearchHelpComponent_Factory(t) { return new (t || SearchHelpComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(EntityService)); };
SearchHelpComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SearchHelpComponent, selectors: [["dk-app-search-help"]], decls: 26, vars: 15, consts: [["id", "searchHelp", "tabindex", "-1", "role", "dialog", 1, "modal", "fade", 3, "ngClass", "ngStyle"], ["role", "document", 1, "modal-dialog", "modal-dialog-centered", "modal-lg"], [1, "modal-content", "dk-search-help-content"], [1, "modal-header", "dk-search-help-header"], ["id", "addRelationship", 1, "modal-title"], ["type", "button", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], ["class", "card mb-2", 4, "ngIf"], ["type", "button", "class", "btn btn-link float-right", 3, "click", 4, "ngIf"], [1, "table", "table-bordered", "table-sm", "table-hover", "dk-search-table"], [1, "thead-light"], ["scope", "col"], ["type", "checkbox", 3, "ngModel", "ngModelChange", "click", 4, "ngIf"], [3, "display", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], [1, "modal-footer", "dk-search-help-footer"], ["type", "button", 1, "btn", "btn-sm", "btn-secondary", 3, "click"], ["type", "button", 1, "btn", "btn-sm", "btn-primary", 3, "disabled", "click"], [1, "card", "mb-2"], ["class", "mt-2 mx-2 row", 4, "ngIf"], [1, "mt-2", "mx-2", "row", 3, "formGroup"], ["class", "col-6 form-group row", 4, "ngFor", "ngForOf"], [1, "mb-2"], ["type", "button", "id", "search", 1, "btn", "btn-sm", "btn-primary", "float-right", "mr-2", 3, "click"], [1, "mt-2", "mx-2", "row"], ["type", "text", "placeholder", "Search", 1, "form-control", 3, "ngModel", "ngModelChange", "keyup"], [1, "col-6", "form-group", "row"], [1, "col-6", "col-form-label", "col-form-label-sm", "text-right", 3, "for"], ["type", "text", 1, "col-6", "form-control", "form-control-sm", 3, "id", "name", "formControlName", "readonly", "keyup"], ["type", "button", 1, "btn", "btn-link", "float-right", 3, "click"], ["type", "checkbox", 3, "ngModel", "ngModelChange", "click"], ["type", "radio", "name", "selectedIndex", 3, "value", "ngModel", "ngModelChange", "dblclick", 4, "ngIf"], ["type", "checkbox", 3, "ngModel", "ngModelChange", 4, "ngIf"], ["type", "radio", "name", "selectedIndex", 3, "value", "ngModel", "ngModelChange", "dblclick"], ["type", "checkbox", 3, "ngModel", "ngModelChange"]], template: function SearchHelpComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h6", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 5);
        ɵngcc0.ɵɵlistener("click", function SearchHelpComponent_Template_button_click_6_listener() { return ctx.closeSearchHelpModal(); });
        ɵngcc0.ɵɵelementStart(7, "span", 6);
        ɵngcc0.ɵɵtext(8, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵtemplate(10, SearchHelpComponent_div_10_Template, 7, 3, "div", 8);
        ɵngcc0.ɵɵtemplate(11, SearchHelpComponent_button_11_Template, 2, 0, "button", 9);
        ɵngcc0.ɵɵtemplate(12, SearchHelpComponent_button_12_Template, 2, 0, "button", 9);
        ɵngcc0.ɵɵelementStart(13, "table", 10);
        ɵngcc0.ɵɵelementStart(14, "thead", 11);
        ɵngcc0.ɵɵelementStart(15, "tr");
        ɵngcc0.ɵɵelementStart(16, "th", 12);
        ɵngcc0.ɵɵtemplate(17, SearchHelpComponent_input_17_Template, 1, 1, "input", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, SearchHelpComponent_th_18_Template, 2, 3, "th", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "tbody");
        ɵngcc0.ɵɵtemplate(20, SearchHelpComponent_tr_20_Template, 5, 3, "tr", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 16);
        ɵngcc0.ɵɵelementStart(22, "button", 17);
        ɵngcc0.ɵɵlistener("click", function SearchHelpComponent_Template_button_click_22_listener() { return ctx.closeSearchHelpModal(); });
        ɵngcc0.ɵɵtext(23, "Cancel");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "button", 18);
        ɵngcc0.ɵɵlistener("click", function SearchHelpComponent_Template_button_click_24_listener() { return ctx.confirmSelection(); });
        ɵngcc0.ɵɵtext(25, "Confirm");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c0, ctx.isSearchHelpModalShown))("ngStyle", ɵngcc0.ɵɵpureFunction1(13, _c1, ctx.displaySearchHelpModal));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.searchHelp == null ? null : ctx.searchHelp.OBJECT_NAME, " (", ctx.listData.length, ")");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isFilterShown);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isFilterShown);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isFilterShown);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.searchHelp == null ? null : ctx.searchHelp.MULTI);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.listFields);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.listData);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("disabled", ctx.searchHelp == null ? null : ctx.searchHelp.READ_ONLY);
    } }, directives: [ɵngcc4.NgClass, ɵngcc4.NgStyle, ɵngcc4.NgIf, ɵngcc4.NgForOf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.FormControlName, ɵngcc3.CheckboxControlValueAccessor, ɵngcc3.RadioControlValueAccessor], styles: [".dk-search-help-header[_ngcontent-%COMP%]{background-color:#e9ecef;padding:.3rem .5rem}.dk-search-help-footer[_ngcontent-%COMP%]{padding:.5rem}.dk-search-table[_ngcontent-%COMP%]{border:none;display:block;max-height:20rem;overflow:scroll;white-space:nowrap}.dk-search-help-content[_ngcontent-%COMP%]{border:1px solid rgba(0,0,0,.4);box-shadow:8px 5px 5px rgba(0,0,0,.2)}.dk-search-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{position:-webkit-sticky;position:sticky;top:0;z-index:2}"] });
/** @nocollapse */
SearchHelpComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: EntityService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SearchHelpComponent, [{
        type: Component,
        args: [{
                selector: 'dk-app-search-help',
                template: "<div class=\"modal fade\" id=\"searchHelp\" tabindex=\"-1\" role=\"dialog\"\n     [ngClass]=\"{'show': isSearchHelpModalShown}\" [ngStyle]=\"{'display': displaySearchHelpModal}\">\n  <div class=\"modal-dialog modal-dialog-centered modal-lg\" role=\"document\">\n    <div class=\"modal-content dk-search-help-content\">\n      <div class=\"modal-header dk-search-help-header\">\n        <h6 class=\"modal-title\" id=\"addRelationship\">{{searchHelp?.OBJECT_NAME}} ({{listData.length}})</h6>\n        <button type=\"button\" class=\"close\" (click)=\"closeSearchHelpModal()\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n\n      <div class=\"modal-body\">\n        <div *ngIf=\"isFilterShown\" class=\"card mb-2\">\n          <div *ngIf=\"searchHelp && searchHelp.FUZZY_SEARCH\" class=\"mt-2 mx-2 row\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"Search\" [(ngModel)]=\"fuzzySearchTerm\" (keyup)=\"enterSearch($event)\">\n          </div>\n          <div class=\"mt-2 mx-2 row\" [formGroup]=\"filterFieldsFormGroup\">\n            <div *ngFor=\"let filterField of filterFields\" class=\"col-6 form-group row\">\n              <label for=\"{{filterField.FIELD_NAME}}\" class=\"col-6 col-form-label col-form-label-sm text-right\">\n                {{filterField.LABEL_TEXT || filterField.FIELD_NAME}}:</label>\n              <input id=\"{{filterField.FIELD_NAME}}\" name=\"{{filterField.FIELD_NAME}}\" formControlName=\"{{filterField.FIELD_NAME}}\"\n                     type=\"text\" class=\"col-6 form-control form-control-sm\" [readonly]=\"filterField.FILTER_DISP_ONLY\" (keyup)=\"enterSearch($event)\">\n            </div>\n          </div>\n\n          <div class=\"mb-2\">\n            <button type=\"button\" id=\"search\" class=\"btn btn-sm btn-primary float-right mr-2\" (click)=\"search()\">\n              Search\n            </button>\n          </div>\n        </div>\n\n        <button *ngIf=\"!isFilterShown\" type=\"button\" class=\"btn btn-link float-right\" (click)=\"showFilter()\">Show Filter</button>\n        <button *ngIf=\"isFilterShown\" type=\"button\" class=\"btn btn-link float-right\" (click)=\"hideFilter()\">Hide Filter</button>\n\n        <table class=\"table table-bordered table-sm table-hover dk-search-table\">\n          <thead class=\"thead-light\">\n          <tr>\n            <th scope=\"col\">\n              <input *ngIf=\"searchHelp?.MULTI\" type=\"checkbox\" [(ngModel)]=\"isSelectAllChecked\" (click)=\"selectAll()\">\n            </th>\n            <th *ngFor=\"let listField of listFields\"\n                [style.display]=\"listField.FIELD_NAME === 'INSTANCE_GUID' ? 'none' : 'table-cell'\">\n              {{listField.LIST_HEADER_TEXT || listField.FIELD_NAME}}\n            </th>\n          </tr>\n          </thead>\n\n          <tbody>\n          <tr *ngFor=\"let item of listData; let i = index\">\n            <td>\n              <input *ngIf=\"!searchHelp.MULTI\" type=\"radio\" name=\"selectedIndex\" [value]=\"i\" [(ngModel)]=\"selectedIndex\" (dblclick)=\"confirmSelection()\">\n              <input *ngIf=\"searchHelp.MULTI\" type=\"checkbox\" [(ngModel)]=\"item.SELECTED\">\n            </td>\n            <td *ngFor=\"let listField of listFields\"\n                [style.display]=\"listField.FIELD_NAME === 'INSTANCE_GUID' ? 'none' : 'table-cell'\">\n              {{item[listField.FIELD_NAME]}}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n\n      <div class=\"modal-footer dk-search-help-footer\">\n        <button type=\"button\" class=\"btn btn-sm btn-secondary\" (click)=\"closeSearchHelpModal()\">Cancel</button>\n        <button type=\"button\" class=\"btn btn-sm btn-primary\" (click)=\"confirmSelection()\" [disabled]=\"searchHelp?.READ_ONLY\">Confirm</button>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: [".dk-search-help-header{background-color:#e9ecef;padding:.3rem .5rem}.dk-search-help-footer{padding:.5rem}.dk-search-table{border:none;display:block;max-height:20rem;overflow:scroll;white-space:nowrap}.dk-search-help-content{border:1px solid rgba(0,0,0,.4);box-shadow:8px 5px 5px rgba(0,0,0,.2)}.dk-search-table th{position:-webkit-sticky;position:sticky;top:0;z-index:2}"]
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: EntityService }]; }, null); })();
if (false) {
    /** @type {?} */
    SearchHelpComponent.prototype.isSearchHelpModalShown;
    /** @type {?} */
    SearchHelpComponent.prototype.isFilterShown;
    /** @type {?} */
    SearchHelpComponent.prototype.isSelectAllChecked;
    /** @type {?} */
    SearchHelpComponent.prototype.searchHelp;
    /** @type {?} */
    SearchHelpComponent.prototype.fuzzySearchTerm;
    /** @type {?} */
    SearchHelpComponent.prototype.selectedIndex;
    /** @type {?} */
    SearchHelpComponent.prototype.filterFields;
    /** @type {?} */
    SearchHelpComponent.prototype.listFields;
    /** @type {?} */
    SearchHelpComponent.prototype.filterFieldsFormGroup;
    /** @type {?} */
    SearchHelpComponent.prototype.exportControl;
    /** @type {?} */
    SearchHelpComponent.prototype.afterExportFn;
    /** @type {?} */
    SearchHelpComponent.prototype.listData;
    /** @type {?} */
    SearchHelpComponent.prototype.preSearchHelpParas;
    /**
     * @type {?}
     * @private
     */
    SearchHelpComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    SearchHelpComponent.prototype.entityService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/attribute/attribute-base.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AttributeBase {
    constructor() {
        this.dropdownList = [];
    }
}
if (false) {
    /** @type {?} */
    AttributeBase.prototype.controlType;
    /** @type {?} */
    AttributeBase.prototype.key;
    /** @type {?} */
    AttributeBase.prototype.name;
    /** @type {?} */
    AttributeBase.prototype.label;
    /** @type {?} */
    AttributeBase.prototype.list_label;
    /** @type {?} */
    AttributeBase.prototype.relationId;
    /** @type {?} */
    AttributeBase.prototype.maxLength;
    /** @type {?} */
    AttributeBase.prototype.step;
    /** @type {?} */
    AttributeBase.prototype.domainId;
    /** @type {?} */
    AttributeBase.prototype.placeholder;
    /** @type {?} */
    AttributeBase.prototype.pattern;
    /** @type {?} */
    AttributeBase.prototype.domainEntityId;
    /** @type {?} */
    AttributeBase.prototype.domainRelationId;
    /** @type {?} */
    AttributeBase.prototype.searchHelpId;
    /** @type {?} */
    AttributeBase.prototype.searchHelpExportField;
    /** @type {?} */
    AttributeBase.prototype.primaryKey;
    /** @type {?} */
    AttributeBase.prototype.autoIncrement;
    /** @type {?} */
    AttributeBase.prototype.dropdownList;
}
class DropdownList {
}
if (false) {
    /** @type {?} */
    DropdownList.prototype.key;
    /** @type {?} */
    DropdownList.prototype.value;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/attribute/attribute-validators.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// noinspection JSAnnotator
class DomainValueValidator {
    /**
     * @param {?} entityService
     */
    constructor(entityService) {
        this.entityService = entityService;
    }
    /**
     * @param {?} ctrl
     * @return {?}
     */
    validate(ctrl) {
        /** @type {?} */
        const queryObject = new QueryObject();
        // queryObject.ENTITY_ID = entityID;
        // queryObject.RELATION_ID = relationID;
        // queryObject.FILTER = [{FIELD_NAME: searchField, OPERATOR: 'EQ', LOW: ctrl.value}];
        return this.entityService.searchEntities(queryObject).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            if (data['msgName']) {
                return { message: data['msgName']['msgShortText'] };
            }
            else {
                if (data.length === 0) {
                    return { message: 'Value is invalid' };
                }
                else {
                    return null;
                }
            }
        })), catchError((/**
         * @return {?}
         */
        () => null)));
    }
}
DomainValueValidator.ɵfac = function DomainValueValidator_Factory(t) { return new (t || DomainValueValidator)(ɵngcc0.ɵɵinject(EntityService)); };
/** @nocollapse */
DomainValueValidator.ctorParameters = () => [
    { type: EntityService }
];
/** @nocollapse */ DomainValueValidator.ɵprov = ɵɵdefineInjectable({ factory: function DomainValueValidator_Factory() { return new DomainValueValidator(ɵɵinject(EntityService)); }, token: DomainValueValidator, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DomainValueValidator, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: EntityService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    DomainValueValidator.prototype.entityService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/attribute/attribute-control.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AttributeControlService {
    /**
     * @param {?} entityService
     * @param {?} domainValueValidator
     */
    constructor(entityService, domainValueValidator) {
        this.entityService = entityService;
        this.domainValueValidator = domainValueValidator;
    }
    /**
     * @param {?} attributes
     * @return {?}
     */
    toAttributeControl(attributes) {
        /** @type {?} */
        const attributeControls = [];
        if (!attributes) {
            return attributeControls;
        }
        attributes.forEach((/**
         * @param {?} attribute
         * @return {?}
         */
        attribute => attributeControls.push(this.toSingleAttributeControl(attribute))));
        return attributeControls;
    }
    /**
     * @param {?} attribute
     * @return {?}
     */
    toSingleAttributeControl(attribute) {
        /** @type {?} */
        const attributeControl = new AttributeBase();
        attributeControl.key = attribute.ATTR_GUID;
        attributeControl.name = attribute.ATTR_NAME;
        attributeControl.label = attribute.LABEL_TEXT;
        attributeControl.list_label = attribute.LIST_HEADER_TEXT;
        attributeControl.relationId = attribute.RELATION_ID;
        attributeControl.searchHelpId = attribute.SEARCH_HELP_ID;
        attributeControl.searchHelpExportField = attribute.SEARCH_HELP_EXPORT_FIELD;
        attributeControl.domainId = attribute.DOMAIN_ID;
        attributeControl.domainEntityId = attribute.DOMAIN_ENTITY_ID;
        attributeControl.domainRelationId = attribute.DOMAIN_RELATION_ID;
        switch (attribute.DATA_TYPE) {
            case 1: // Char
                if (attribute.CAPITAL_ONLY) {
                    attributeControl.controlType = 'text_capital';
                    // onkeyup="this.value = this.value.toUpperCase();"
                }
                else {
                    if (attribute.DOMAIN_TYPE === 3) {
                        attributeControl.controlType = 'dropdown';
                        this._generateDropdownList(attribute.DOMAIN_ID, attributeControl);
                    }
                    else {
                        attributeControl.controlType = 'text';
                        attributeControl.pattern = attribute.REG_EXPR;
                    }
                }
                attributeControl.maxLength = attribute.DATA_LENGTH;
                attributeControl.primaryKey = attribute.PRIMARY_KEY;
                break;
            case 2: // Integer
                if (attribute.DOMAIN_TYPE === 3) {
                    attributeControl.controlType = 'dropdown';
                    this._generateDropdownList(attribute.DOMAIN_ID, attributeControl);
                }
                else {
                    attributeControl.controlType = 'integer';
                    if (attribute.UNSIGNED) {
                        attributeControl.pattern = '^\\d+([^.,])?$';
                    }
                    attributeControl.autoIncrement = attribute.AUTO_INCREMENT;
                }
                attributeControl.primaryKey = attribute.PRIMARY_KEY;
                break;
            case 3: // Boolean
                attributeControl.controlType = 'checkbox';
                break;
            case 4: // Decimal
                attributeControl.controlType = 'decimal';
                this._setDecimalPattern(attributeControl, attribute);
                break;
            case 5: // String
                attributeControl.controlType = 'textarea';
                break;
            case 6: // Binary
                attributeControl.controlType = 'file';
                break;
            case 7: // Date
                attributeControl.controlType = 'date';
                break;
            case 8: // Timestamp
                attributeControl.controlType = 'timestamp';
                break;
            default:
                attributeControl.controlType = 'text';
        }
        return attributeControl;
    }
    /**
     * @param {?} domainID
     * @param {?} attributeControl
     * @return {?}
     */
    _generateDropdownList(domainID, attributeControl) {
        this.entityService.getDataDomain(domainID)
            .subscribe((/**
         * @param {?} dataDomain
         * @return {?}
         */
        dataDomain => dataDomain['DOMAIN_VALUES'].forEach((/**
         * @param {?} domainValue
         * @return {?}
         */
        domainValue => {
            attributeControl.dropdownList.push({
                key: domainValue['LOW_VALUE'],
                value: domainValue['LOW_VALUE_TEXT'] || domainValue['LOW_VALUE']
            });
        }))));
    }
    /**
     * @param {?} attributeControl
     * @param {?} attribute
     * @return {?}
     */
    _setDecimalPattern(attributeControl, attribute) {
        /** @type {?} */
        const zeroPadding = '0000000000000000000000000000000000000';
        attributeControl.step = '0.' + zeroPadding.substr(0, attribute.DECIMAL - 1) + '1';
        attributeControl.placeholder = '0.' + zeroPadding.substr(0, attribute.DECIMAL - 1) + '0';
        /** @type {?} */
        const integerPlace = attribute.DATA_LENGTH - attribute.DECIMAL;
        attributeControl.pattern = attribute.UNSIGNED ? '^(' : '^(\\-?';
        attributeControl.pattern += integerPlace ? '\\d{1,' + integerPlace.toString() + '})' : '0)';
        attributeControl.pattern += '(\\.\\d{1,' + attribute.DECIMAL + '})?$';
        attributeControl.maxLength = attribute.DATA_LENGTH;
    }
    /**
     * @param {?} attribute
     * @param {?} instance
     * @return {?}
     */
    convertToFormControl(attribute, instance) {
        /** @type {?} */
        const formControl = new FormControl(instance[attribute.ATTR_NAME] || '');
        if (attribute.PRIMARY_KEY && !attribute.AUTO_INCREMENT) {
            formControl.setValidators(Validators.required);
        }
        // if (attribute.DOMAIN_TYPE === 2 && !attribute.PRIMARY_KEY) {
        //   formControl.setAsyncValidators(this.domainValueValidator.validate.bind(this.domainValueValidator));
        // }
        return formControl;
    }
    /**
     * @param {?} attributes
     * @param {?} instance
     * @param {?=} isDirty
     * @return {?}
     */
    convertToFormGroup(attributes, instance, isDirty) {
        /** @type {?} */
        const group = {};
        attributes.forEach((/**
         * @param {?} attribute
         * @return {?}
         */
        attribute => {
            group[attribute.ATTR_NAME] = this.convertToFormControl(attribute, instance);
            if (instance[attribute.ATTR_NAME] && isDirty) {
                group[attribute.ATTR_NAME].markAsDirty();
            }
        }));
        return new FormGroup(group);
    }
}
AttributeControlService.ɵfac = function AttributeControlService_Factory(t) { return new (t || AttributeControlService)(ɵngcc0.ɵɵinject(EntityService), ɵngcc0.ɵɵinject(DomainValueValidator)); };
/** @nocollapse */
AttributeControlService.ctorParameters = () => [
    { type: EntityService },
    { type: DomainValueValidator }
];
/** @nocollapse */ AttributeControlService.ɵprov = ɵɵdefineInjectable({ factory: function AttributeControlService_Factory() { return new AttributeControlService(ɵɵinject(EntityService), ɵɵinject(DomainValueValidator)); }, token: AttributeControlService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AttributeControlService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: EntityService }, { type: DomainValueValidator }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AttributeControlService.prototype.entityService;
    /**
     * @type {?}
     * @private
     */
    AttributeControlService.prototype.domainValueValidator;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/attribute/attribute.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AttributeComponent {
    constructor() {
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const fieldCtrl = this.formGroup.get(this.attributeControl.name);
        switch (this.attributeControl.controlType) {
            case 'timestamp':
                if (!this.readonly && !fieldCtrl.value) {
                    /** @type {?} */
                    const currentTimestamp = new Date();
                    fieldCtrl.setValue(currentTimestamp.getFullYear() + '-' + ('0' + (currentTimestamp.getMonth() + 1)).slice(-2) + '-'
                        + ('0' + currentTimestamp.getDate()).slice(-2) + ' ' + ('0' + currentTimestamp.getHours()).slice(-2) +
                        ':' + ('0' + currentTimestamp.getMinutes()).slice(-2) + ':' + ('0' + currentTimestamp.getSeconds()).slice(-2));
                    fieldCtrl.markAsDirty();
                }
                break;
            case 'date':
                if (!this.readonly && !fieldCtrl.value) {
                    /** @type {?} */
                    const currentDate = new Date();
                    fieldCtrl.setValue(currentDate.getFullYear() + '-' + ('0' + (currentDate.getMonth() + 1)).slice(-2) + '-'
                        + ('0' + currentDate.getDate()).slice(-2));
                    fieldCtrl.markAsDirty();
                }
                break;
            default:
        }
        if (this.attributeControl.domainId === 'UUID' && !this.readonly && !fieldCtrl.value) {
            fieldCtrl.setValue(v4());
            fieldCtrl.markAsDirty();
        }
        if (this.attributeControl.domainId === 'GUID' && !this.readonly && !fieldCtrl.value) {
            /** @type {?} */
            let guid = v4();
            guid = guid.replace(/-/g, '').toUpperCase();
            fieldCtrl.setValue(guid);
            fieldCtrl.markAsDirty();
        }
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.attributeControl.controlType === 'dropdown' ||
            this.attributeControl.controlType === 'checkbox') {
            this.readonly ? this.formGroup.get(this.attributeControl.name).disable() :
                this.formGroup.get(this.attributeControl.name).enable();
        }
    }
    /**
     * @return {?}
     */
    get invalid() { return this.formGroup.controls[this.attributeControl.name].invalid; }
    /**
     * @return {?}
     */
    get errorMessage() {
        /** @type {?} */
        const fieldCtrl = this.formGroup.get(this.attributeControl.name);
        if (fieldCtrl.getError('pattern')) {
            return 'The pattern is not correct';
        }
        else if (fieldCtrl.getError('required')) {
            return 'Required';
        }
        else if (fieldCtrl.getError('message')) {
            return fieldCtrl.getError('message');
        }
        else {
            return null;
        }
    }
    /**
     * @return {?}
     */
    get isReadonly() { return this.readonly || this.attributeControl.autoIncrement; }
    /**
     * @param {?} attributeName
     * @return {?}
     */
    onKeyup(attributeName) {
        /** @type {?} */
        const fieldCtrl = this.formGroup.get(attributeName);
        fieldCtrl.setValue(fieldCtrl.value.toUpperCase());
    }
    /**
     * @param {?} attributeControl
     * @return {?}
     */
    onSearchHelp(attributeControl) {
        if (attributeControl.searchHelpId) {
            this.searchHelpComponent.openSearchHelpModalBySearchHelp(attributeControl.searchHelpId, attributeControl.searchHelpExportField, attributeControl.name, this.formGroup, this.readonly);
        }
        else {
            this.searchHelpComponent.openSearchHelpModalByEntity(attributeControl.domainEntityId, attributeControl.domainRelationId, this.formGroup, this.readonly, attributeControl.name, attributeControl.domainId);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onChange(event) {
        this.change.emit(event);
    }
}
AttributeComponent.ɵfac = function AttributeComponent_Factory(t) { return new (t || AttributeComponent)(); };
AttributeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttributeComponent, selectors: [["dk-app-attribute"]], viewQuery: function AttributeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(SearchHelpComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchHelpComponent = _t.first);
    } }, inputs: { attributeControl: "attributeControl", formGroup: "formGroup", readonly: "readonly", isSmallSize: "isSmallSize", noErrorMsg: "noErrorMsg" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 12, vars: 11, consts: [[3, "formGroup"], [3, "ngSwitch"], ["class", "input-group", 4, "ngIf"], ["type", "number", "class", "form-control", 3, "form-control-sm", "formControlName", "id", "step", "placeholder", "pattern", "readonly", "change", 4, "ngSwitchCase"], ["type", "checkbox", "class", "mb-1 ml-1", 3, "form-control-sm", "formControlName", "id", "change", 4, "ngSwitchCase"], ["type", "textarea", "class", "form-control", 3, "form-control-sm", "formControlName", "id", "readonly", "change", 4, "ngSwitchCase"], ["type", "file", "class", "form-control", 3, "form-control-sm", "formControlName", "id", "readonly", "change", 4, "ngSwitchCase"], ["type", "date", "class", "form-control", 3, "form-control-sm", "formControlName", "id", "readonly", "change", 4, "ngSwitchCase"], ["type", "text", "class", "form-control", 3, "form-control-sm", "formControlName", "id", "readonly", "change", 4, "ngSwitchCase"], ["class", "form-control", 3, "form-control-sm", "formControlName", "id", "change", 4, "ngSwitchCase"], ["class", "dk-invalid-feedback", 3, "ng-invalid", 4, "ngIf"], [1, "input-group"], ["type", "text", "class", "form-control", 3, "form-control-sm", "formControlName", "id", "maxlength", "pattern", "readonly", "change", 4, "ngSwitchCase"], ["type", "text", "class", "form-control", 3, "form-control-sm", "formControlName", "id", "maxlength", "readonly", "keyup", "change", 4, "ngSwitchCase"], ["type", "number", "class", "form-control", 3, "form-control-sm", "formControlName", "id", "pattern", "readonly", "change", 4, "ngSwitchCase"], ["class", "input-group-append", 4, "ngIf"], ["type", "text", 1, "form-control", 3, "formControlName", "id", "maxlength", "pattern", "readonly", "change"], ["type", "text", 1, "form-control", 3, "formControlName", "id", "maxlength", "readonly", "keyup", "change"], ["type", "number", 1, "form-control", 3, "formControlName", "id", "pattern", "readonly", "change"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-outline-secondary", "btn-sm", 3, "click"], [1, "fas", "fa-search"], ["type", "number", 1, "form-control", 3, "formControlName", "id", "step", "placeholder", "pattern", "readonly", "change"], ["type", "checkbox", 1, "mb-1", "ml-1", 3, "formControlName", "id", "change"], ["type", "textarea", 1, "form-control", 3, "formControlName", "id", "readonly", "change"], ["type", "file", 1, "form-control", 3, "formControlName", "id", "readonly", "change"], ["type", "date", 1, "form-control", 3, "formControlName", "id", "readonly", "change"], ["type", "text", 1, "form-control", 3, "formControlName", "id", "readonly", "change"], [1, "form-control", 3, "formControlName", "id", "change"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "dk-invalid-feedback"]], template: function AttributeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, AttributeComponent_div_2_Template, 5, 4, "div", 2);
        ɵngcc0.ɵɵtemplate(3, AttributeComponent_input_3_Template, 1, 8, "input", 3);
        ɵngcc0.ɵɵtemplate(4, AttributeComponent_input_4_Template, 1, 4, "input", 4);
        ɵngcc0.ɵɵtemplate(5, AttributeComponent_input_5_Template, 1, 5, "input", 5);
        ɵngcc0.ɵɵtemplate(6, AttributeComponent_input_6_Template, 1, 5, "input", 6);
        ɵngcc0.ɵɵtemplate(7, AttributeComponent_input_7_Template, 1, 5, "input", 7);
        ɵngcc0.ɵɵtemplate(8, AttributeComponent_input_8_Template, 1, 5, "input", 8);
        ɵngcc0.ɵɵtemplate(9, AttributeComponent_select_9_Template, 2, 5, "select", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, AttributeComponent_div_10_Template, 2, 3, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(11, "dk-app-search-help");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.attributeControl.controlType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.attributeControl.controlType === "text" || ctx.attributeControl.controlType === "text_capital" || ctx.attributeControl.controlType === "integer");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "decimal");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "checkbox");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "textarea");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "file");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "date");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "timestamp");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "dropdown");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.noErrorMsg);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgSwitch, ɵngcc4.NgIf, ɵngcc4.NgSwitchCase, SearchHelpComponent, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.MaxLengthValidator, ɵngcc3.PatternValidator, ɵngcc3.NumberValueAccessor, ɵngcc3.CheckboxControlValueAccessor, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], styles: [""] });
/** @nocollapse */
AttributeComponent.ctorParameters = () => [];
AttributeComponent.propDecorators = {
    attributeControl: [{ type: Input }],
    formGroup: [{ type: Input }],
    readonly: [{ type: Input }],
    isSmallSize: [{ type: Input }],
    noErrorMsg: [{ type: Input }],
    change: [{ type: Output }],
    searchHelpComponent: [{ type: ViewChild, args: [SearchHelpComponent, { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AttributeComponent, [{
        type: Component,
        args: [{
                selector: 'dk-app-attribute',
                template: "<div [formGroup]=\"formGroup\">\n  <div [ngSwitch]=\"attributeControl.controlType\">\n    <div *ngIf=\"attributeControl.controlType === 'text' ||\n                attributeControl.controlType === 'text_capital' ||\n                attributeControl.controlType === 'integer'\" class=\"input-group\">\n      <input *ngSwitchCase=\"'text'\" type=\"text\" class=\"form-control\"\n             [class.form-control-sm] = \"isSmallSize\"\n             [formControlName]=\"attributeControl.name\"\n             [id]=\"attributeControl.key\"\n             [maxlength]=\"attributeControl.maxLength\"\n             [pattern]=\"attributeControl.pattern\"\n             (change) = \"onChange($event)\"\n             [readonly]=\"isReadonly\">\n      <input *ngSwitchCase=\"'text_capital'\" type=\"text\" class=\"form-control\"\n             [class.form-control-sm] = \"isSmallSize\"\n             [formControlName]=\"attributeControl.name\"\n             [id]=\"attributeControl.key\"\n             [maxlength]=\"attributeControl.maxLength\"\n             (keyup)=\"onKeyup(attributeControl.name)\"\n             (change) = \"onChange($event)\"\n             [readonly]=\"isReadonly\" >\n      <input *ngSwitchCase=\"'integer'\" type=\"number\" class=\"form-control\"\n             [class.form-control-sm] = \"isSmallSize\"\n             [formControlName]=\"attributeControl.name\"\n             [id]=\"attributeControl.key\"\n             [pattern]=\"attributeControl.pattern\"\n             (change) = \"onChange($event)\"\n             [readonly]=\"isReadonly\" >\n      <div *ngIf=\"attributeControl.searchHelpId || attributeControl.domainRelationId\" class=\"input-group-append\">\n        <button class=\"btn btn-outline-secondary btn-sm\" type=\"button\" (click)=\"onSearchHelp(attributeControl)\">\n          <span class=\"fas fa-search\"></span>\n        </button>\n      </div>\n    </div>\n    <input *ngSwitchCase=\"'decimal'\" type=\"number\" class=\"form-control\"\n           [class.form-control-sm] = \"isSmallSize\"\n           [formControlName]=\"attributeControl.name\"\n           [id]=\"attributeControl.key\"\n           [step]=\"attributeControl.step\"\n           [placeholder]=\"attributeControl.placeholder\"\n           [pattern]=\"attributeControl.pattern\"\n           (change) = \"onChange($event)\"\n           [readonly]=\"isReadonly\" >\n    <input *ngSwitchCase=\"'checkbox'\" type=\"checkbox\" class=\"mb-1 ml-1\"\n           [class.form-control-sm] = \"isSmallSize\"\n           [formControlName]=\"attributeControl.name\"\n           (change) = \"onChange($event)\"\n           [id]=\"attributeControl.key\">\n    <input *ngSwitchCase=\"'textarea'\" type=\"textarea\" class=\"form-control\"\n           [class.form-control-sm] = \"isSmallSize\"\n           [formControlName]=\"attributeControl.name\"\n           [id]=\"attributeControl.key\"\n           (change) = \"onChange($event)\"\n           [readonly]=\"isReadonly\" >\n    <input *ngSwitchCase=\"'file'\" type=\"file\" class=\"form-control\"\n           [class.form-control-sm] = \"isSmallSize\"\n           [formControlName]=\"attributeControl.name\"\n           [id]=\"attributeControl.key\"\n           (change) = \"onChange($event)\"\n           [readonly]=\"isReadonly\" >\n    <input *ngSwitchCase=\"'date'\" type=\"date\" class=\"form-control\"\n           [class.form-control-sm] = \"isSmallSize\"\n           [formControlName]=\"attributeControl.name\"\n           [id]=\"attributeControl.key\"\n           (change) = \"onChange($event)\"\n           [readonly]=\"isReadonly\" >\n    <input *ngSwitchCase=\"'timestamp'\" type=\"text\" class=\"form-control\"\n           [class.form-control-sm] = \"isSmallSize\"\n           [formControlName]=\"attributeControl.name\"\n           [id]=\"attributeControl.key\"\n           (change) = \"onChange($event)\"\n           [readonly]=\"isReadonly\" >\n    <select *ngSwitchCase=\"'dropdown'\" class=\"form-control\"\n            [class.form-control-sm] = \"isSmallSize\"\n            [formControlName]=\"attributeControl.name\"\n            [id]=\"attributeControl.key\"\n            (change) = \"onChange($event)\">\n      <option *ngFor=\"let opt of attributeControl.dropdownList\" [value]=\"opt.key\">{{opt.value}}</option>\n    </select>\n  </div>\n\n  <div *ngIf=\"!noErrorMsg\" [class.ng-invalid]=\"invalid\" class=\"dk-invalid-feedback\">\n    {{errorMessage}}\n  </div>\n</div>\n\n<dk-app-search-help></dk-app-search-help>\n",
                styles: [""]
            }]
    }], function () { return []; }, { change: [{
            type: Output
        }], attributeControl: [{
            type: Input
        }], formGroup: [{
            type: Input
        }], readonly: [{
            type: Input
        }], isSmallSize: [{
            type: Input
        }], noErrorMsg: [{
            type: Input
        }], searchHelpComponent: [{
            type: ViewChild,
            args: [SearchHelpComponent, { static: false }]
        }] }); })();
if (false) {
    /** @type {?} */
    AttributeComponent.prototype.attributeControl;
    /** @type {?} */
    AttributeComponent.prototype.formGroup;
    /** @type {?} */
    AttributeComponent.prototype.readonly;
    /** @type {?} */
    AttributeComponent.prototype.isSmallSize;
    /** @type {?} */
    AttributeComponent.prototype.noErrorMsg;
    /** @type {?} */
    AttributeComponent.prototype.change;
    /**
     * @type {?}
     * @private
     */
    AttributeComponent.prototype.searchHelpComponent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/attribute/attribute-form/attribute-form.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AttributeFormComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
AttributeFormComponent.ɵfac = function AttributeFormComponent_Factory(t) { return new (t || AttributeFormComponent)(); };
AttributeFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttributeFormComponent, selectors: [["dk-app-attribute-form"]], inputs: { attributeControl: "attributeControl", formGroup: "formGroup", readonly: "readonly", isSmallSize: "isSmallSize" }, decls: 6, vars: 10, consts: [[1, "form-group", "row", 3, "formGroup"], [1, "col-4", "col-form-label", "text-right"], ["class", "primaryKey", 4, "ngIf"], [1, "col-8", 3, "attributeControl", "formGroup", "isSmallSize", "readonly"], [1, "primaryKey"]], template: function AttributeFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "label", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵtemplate(3, AttributeFormComponent_strong_3_Template, 2, 0, "strong", 2);
        ɵngcc0.ɵɵtext(4, ": ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "dk-app-attribute", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("form-control-sm", ctx.isSmallSize);
        ɵngcc0.ɵɵattribute("for", ctx.attributeControl.key);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.attributeControl.label, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.attributeControl.primaryKey);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("attributeControl", ctx.attributeControl)("formGroup", ctx.formGroup)("isSmallSize", ctx.isSmallSize)("readonly", ctx.readonly);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgIf, AttributeComponent], styles: [""] });
/** @nocollapse */
AttributeFormComponent.ctorParameters = () => [];
AttributeFormComponent.propDecorators = {
    attributeControl: [{ type: Input }],
    formGroup: [{ type: Input }],
    readonly: [{ type: Input }],
    isSmallSize: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AttributeFormComponent, [{
        type: Component,
        args: [{
                selector: 'dk-app-attribute-form',
                template: "<div class=\"form-group row\" [formGroup]=\"formGroup\">\n  <label class=\"col-4 col-form-label text-right\"\n         [class.form-control-sm]=\"isSmallSize\"\n         [attr.for]=\"attributeControl.key\">\n    {{attributeControl.label}}<strong *ngIf=\"attributeControl.primaryKey\" class=\"primaryKey\">*</strong>:\n  </label>\n\n  <dk-app-attribute class=\"col-8\" [attributeControl]=\"attributeControl\" [formGroup]=\"formGroup\"\n                 [isSmallSize]=\"isSmallSize\" [readonly]=\"readonly\">\n  </dk-app-attribute>\n\n</div>\n",
                styles: [""]
            }]
    }], function () { return []; }, { attributeControl: [{
            type: Input
        }], formGroup: [{
            type: Input
        }], readonly: [{
            type: Input
        }], isSmallSize: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    AttributeFormComponent.prototype.attributeControl;
    /** @type {?} */
    AttributeFormComponent.prototype.formGroup;
    /** @type {?} */
    AttributeFormComponent.prototype.readonly;
    /** @type {?} */
    AttributeFormComponent.prototype.isSmallSize;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/attribute/attribute-form2/attribute-form2.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AttributeForm2Component {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    get invalid() { return this.formGroup.controls[this.attributeControl.name].invalid; }
    /**
     * @return {?}
     */
    get errorMessage() {
        /** @type {?} */
        const fieldCtrl = this.formGroup.get(this.attributeControl.name);
        if (fieldCtrl.getError('pattern')) {
            return 'The pattern is not correct';
        }
        else if (fieldCtrl.getError('required')) {
            return 'Required';
        }
        else if (fieldCtrl.getError('message')) {
            return fieldCtrl.getError('message');
        }
        else {
            return null;
        }
    }
}
AttributeForm2Component.ɵfac = function AttributeForm2Component_Factory(t) { return new (t || AttributeForm2Component)(); };
AttributeForm2Component.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttributeForm2Component, selectors: [["dk-app-attribute-form2"]], inputs: { attributeControl: "attributeControl", formGroup: "formGroup", readonly: "readonly", isSmallSize: "isSmallSize" }, decls: 8, vars: 14, consts: [[1, "form-group", 3, "formGroup"], [1, "col-form-label"], ["class", "primaryKey", 4, "ngIf"], [1, "dk-invalid-feedback"], [3, "attributeControl", "formGroup", "isSmallSize", "readonly", "noErrorMsg"], [1, "primaryKey"]], template: function AttributeForm2Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "label", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵtemplate(3, AttributeForm2Component_strong_3_Template, 2, 0, "strong", 2);
        ɵngcc0.ɵɵtext(4, ": ");
        ɵngcc0.ɵɵelementStart(5, "span", 3);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(7, "dk-app-attribute", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("form-control-sm", ctx.isSmallSize);
        ɵngcc0.ɵɵattribute("for", ctx.attributeControl.key);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.attributeControl.label, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.attributeControl.primaryKey);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("ng-invalid", ctx.invalid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.errorMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("attributeControl", ctx.attributeControl)("formGroup", ctx.formGroup)("isSmallSize", ctx.isSmallSize)("readonly", ctx.readonly)("noErrorMsg", true);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgIf, AttributeComponent], styles: [""] });
/** @nocollapse */
AttributeForm2Component.ctorParameters = () => [];
AttributeForm2Component.propDecorators = {
    attributeControl: [{ type: Input }],
    formGroup: [{ type: Input }],
    readonly: [{ type: Input }],
    isSmallSize: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AttributeForm2Component, [{
        type: Component,
        args: [{
                selector: 'dk-app-attribute-form2',
                template: "<div class=\"form-group\" [formGroup]=\"formGroup\">\n  <label class=\"col-form-label\"\n         [class.form-control-sm]=\"isSmallSize\"\n         [attr.for]=\"attributeControl.key\">\n    {{attributeControl.label}}<strong *ngIf=\"attributeControl.primaryKey\" class=\"primaryKey\">*</strong>:\n    <span [class.ng-invalid]=\"invalid\" class=\"dk-invalid-feedback\">{{errorMessage}}</span>\n  </label>\n\n  <dk-app-attribute [attributeControl]=\"attributeControl\" [formGroup]=\"formGroup\"\n                    [isSmallSize]=\"isSmallSize\" [readonly]=\"readonly\" [noErrorMsg]=\"true\">\n  </dk-app-attribute>\n\n</div>\n",
                styles: [""]
            }]
    }], function () { return []; }, { attributeControl: [{
            type: Input
        }], formGroup: [{
            type: Input
        }], readonly: [{
            type: Input
        }], isSmallSize: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    AttributeForm2Component.prototype.attributeControl;
    /** @type {?} */
    AttributeForm2Component.prototype.formGroup;
    /** @type {?} */
    AttributeForm2Component.prototype.readonly;
    /** @type {?} */
    AttributeForm2Component.prototype.isSmallSize;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/attribute/attribute-table/attribute-table.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AttributeTableComponent {
    constructor() {
        this.isDetailModalShown = false;
        this.isErrorModalShown = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    get displayDetailModal() { return this.isDetailModalShown ? 'block' : 'none'; }
    /**
     * @return {?}
     */
    get displayErrorModal() { return this.isErrorModalShown ? 'block' : 'none'; }
    /**
     * @param {?} index
     * @return {?}
     */
    openDetailModal(index) {
        this.currentFormGroup = this.formArray.at(index);
        this.isDetailModalShown = true;
    }
    /**
     * @return {?}
     */
    closeDetailModal() {
        if (!this.readonly && this.currentFormGroup.dirty) {
            this.currentFormGroup.setValue(this.currentFormGroup.value); // Or the value won't be updated.
        }
        this.isDetailModalShown = false;
    }
    /**
     * @param {?} errorTitle
     * @param {?} errorDescription
     * @return {?}
     */
    openErrorModal(errorTitle, errorDescription) {
        this.errorTitle = errorTitle;
        this.errorDescription = errorDescription;
        this.isErrorModalShown = true;
    }
    /**
     * @return {?}
     */
    closeErrorModal() {
        this.isErrorModalShown = false;
    }
    /**
     * @param {?=} index
     * @return {?}
     */
    deleteRelationInstance(index = 0) {
        switch (this.entityRelation.CARDINALITY) {
            case '[0..n]':
                this.formArray.removeAt(index);
                this.formArray.markAsDirty();
                if (this.formArray.length === 0) {
                    this.entityRelation.EMPTY = true;
                }
                break;
            case '[1..n]':
                if (this.formArray.length === 1) {
                    this.openErrorModal('Deletion Fail', 'The relation requires at lease one entry!');
                }
                else {
                    this.formArray.removeAt(index);
                    this.formArray.markAsDirty();
                }
        }
    }
}
AttributeTableComponent.ɵfac = function AttributeTableComponent_Factory(t) { return new (t || AttributeTableComponent)(); };
AttributeTableComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AttributeTableComponent, selectors: [["dk-app-attribute-table"]], inputs: { attributeControls: "attributeControls", formArray: "formArray", parentFormGroup: "parentFormGroup", entityRelation: "entityRelation", isSmallSize: "isSmallSize", readonly: "readonly" }, decls: 24, vars: 17, consts: [[1, "table", "table-bordered", "relation-table", 3, "formGroup"], [1, "thead-light"], ["scope", "col"], ["scope", "col", 4, "ngFor", "ngForOf"], [3, "formArrayName"], [4, "ngFor", "ngForOf"], ["class", "modal fade dk-modal-open", "id", "detailModal", "tabindex", "-1", "role", "dialog", 3, "ngClass", "ngStyle", 4, "ngIf"], ["id", "errorModal", "tabindex", "-1", "role", "dialog", 1, "modal", "fade", 3, "ngClass", "ngStyle"], ["role", "document", 1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], ["id", "error", 1, "modal-title"], ["type", "button", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], ["class", "primaryKey", 4, "ngIf"], [1, "primaryKey"], [1, "actions"], ["type", "button", "title", "Detail", 1, "btn", 3, "click"], ["class", "fas fa-search", 4, "ngIf"], ["class", "fas fa-pen", 4, "ngIf"], ["type", "button", "title", "Delete", 1, "btn", 3, "disabled", "click"], [1, "far", "fa-trash-alt"], [1, "fas", "fa-search"], [1, "fas", "fa-pen"], [3, "attributeControl", "isSmallSize", "formGroup", "readonly"], ["id", "detailModal", "tabindex", "-1", "role", "dialog", 1, "modal", "fade", "dk-modal-open", 3, "ngClass", "ngStyle"], ["role", "document", 1, "modal-dialog", "modal-lg"], ["id", "detail", 1, "modal-title"], [3, "readonly", "isSmallSize", "attributeControl", "formGroup", 4, "ngFor", "ngForOf"], [3, "readonly", "isSmallSize", "attributeControl", "formGroup"]], template: function AttributeTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "table", 0);
        ɵngcc0.ɵɵelementStart(1, "thead", 1);
        ɵngcc0.ɵɵelementStart(2, "tr");
        ɵngcc0.ɵɵelementStart(3, "th", 2);
        ɵngcc0.ɵɵtext(4, " Action ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, AttributeTableComponent_th_5_Template, 3, 2, "th", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "tbody", 4);
        ɵngcc0.ɵɵtemplate(7, AttributeTableComponent_tr_7_Template, 8, 8, "tr", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, AttributeTableComponent_div_8_Template, 14, 9, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵelementStart(10, "div", 8);
        ɵngcc0.ɵɵelementStart(11, "div", 9);
        ɵngcc0.ɵɵelementStart(12, "div", 10);
        ɵngcc0.ɵɵelementStart(13, "h5", 11);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "button", 12);
        ɵngcc0.ɵɵlistener("click", function AttributeTableComponent_Template_button_click_15_listener() { return ctx.closeErrorModal(); });
        ɵngcc0.ɵɵelementStart(16, "span", 13);
        ɵngcc0.ɵɵtext(17, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 14);
        ɵngcc0.ɵɵelementStart(19, "p");
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 15);
        ɵngcc0.ɵɵelementStart(22, "button", 16);
        ɵngcc0.ɵɵlistener("click", function AttributeTableComponent_Template_button_click_22_listener() { return ctx.closeErrorModal(); });
        ɵngcc0.ɵɵtext(23, "OK");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("table-sm", ctx.isSmallSize);
        ɵngcc0.ɵɵproperty("formGroup", ctx.parentFormGroup);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.attributeControls);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formArrayName", ctx.entityRelation.RELATION_ID);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.formArray.controls);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentFormGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(13, _c0, ctx.isErrorModalShown))("ngStyle", ɵngcc0.ɵɵpureFunction1(15, _c1, ctx.displayErrorModal));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.errorTitle);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ctx.errorDescription);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("btn-sm", ctx.isSmallSize);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgForOf, ɵngcc3.FormArrayName, ɵngcc4.NgIf, ɵngcc4.NgClass, ɵngcc4.NgStyle, AttributeComponent, AttributeFormComponent], styles: [".relation-table[_ngcontent-%COMP%]{border:none;display:block;overflow-x:auto;white-space:nowrap}.actions[_ngcontent-%COMP%]{max-width:6rem;min-width:5rem;width:5rem}.dk-modal-open[_ngcontent-%COMP%]{overflow:auto}"] });
/** @nocollapse */
AttributeTableComponent.ctorParameters = () => [];
AttributeTableComponent.propDecorators = {
    attributeControls: [{ type: Input }],
    formArray: [{ type: Input }],
    parentFormGroup: [{ type: Input }],
    entityRelation: [{ type: Input }],
    isSmallSize: [{ type: Input }],
    readonly: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AttributeTableComponent, [{
        type: Component,
        args: [{
                selector: 'dk-app-attribute-table',
                template: "<table class=\"table table-bordered relation-table\"\n       [class.table-sm]=\"isSmallSize\"\n       [formGroup]=\"parentFormGroup\">\n  <thead class=\"thead-light\">\n  <tr>\n    <th scope=\"col\">\n      Action\n    </th>\n    <th scope=\"col\" *ngFor=\"let attributeControl of attributeControls\">\n      {{attributeControl.label}}<strong *ngIf=\"attributeControl.primaryKey\" class=\"primaryKey\">*</strong>\n    </th>\n  </tr>\n  </thead>\n\n  <tbody [formArrayName]=\"entityRelation.RELATION_ID\">\n    <tr *ngFor=\"let formGroup of formArray.controls; let i = index\">\n      <td class=\"actions\">\n        <button class=\"btn\" [class.btn-sm]=\"isSmallSize\" type=\"button\" (click)=\"openDetailModal(i)\" title=\"Detail\">\n          <span *ngIf=\"readonly\" class=\"fas fa-search\"></span>\n          <span *ngIf=\"!readonly\" class=\"fas fa-pen\"></span>\n        </button>\n        <button class=\"btn\" [class.btn-sm]=\"isSmallSize\" type=\"button\" [disabled]=\"readonly\" (click)=\"deleteRelationInstance(i)\" title=\"Delete\">\n          <span class=\"far fa-trash-alt\"></span>\n        </button>\n      </td>\n      <td *ngFor=\"let attributeControl of attributeControls\">\n        <dk-app-attribute [attributeControl]=\"attributeControl\" [isSmallSize] = \"isSmallSize\"\n                          [formGroup]=\"formGroup\" [readonly]=\"readonly\">\n\n        </dk-app-attribute>\n      </td>\n    </tr>\n  </tbody>\n</table>\n\n<div *ngIf=\"currentFormGroup\" class=\"modal fade dk-modal-open\" [ngClass]=\"{'show': isDetailModalShown}\"\n     [ngStyle]=\"{'display': displayDetailModal}\" id=\"detailModal\" tabindex=\"-1\" role=\"dialog\">\n  <div class=\"modal-dialog modal-lg\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\" id=\"detail\">Line Detail</h5>\n        <button type=\"button\" class=\"close\" (click)=\"closeDetailModal()\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n      <div class=\"modal-body\">\n        <dk-app-attribute-form *ngFor=\"let attributeControl of attributeControls\"\n                               [readonly]=\"readonly\" [isSmallSize]=\"isSmallSize\"\n                            [attributeControl]=\"attributeControl\" [formGroup]=\"currentFormGroup\">\n        </dk-app-attribute-form>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary\" [class.btn-sm]=\"isSmallSize\" (click)=\"closeDetailModal()\">OK</button>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" [ngClass]=\"{'show': isErrorModalShown}\"\n     [ngStyle]=\"{'display': displayErrorModal}\" id=\"errorModal\" tabindex=\"-1\" role=\"dialog\">\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\" id=\"error\">{{errorTitle}}</h5>\n        <button type=\"button\" class=\"close\" (click)=\"closeErrorModal()\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n      <div class=\"modal-body\">\n        <p>{{errorDescription}}</p>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary\" [class.btn-sm]=\"isSmallSize\" (click)=\"closeErrorModal()\">OK</button>\n      </div>\n    </div>\n  </div>\n</div>\n\n",
                styles: [".relation-table{border:none;display:block;overflow-x:auto;white-space:nowrap}.actions{max-width:6rem;min-width:5rem;width:5rem}.dk-modal-open{overflow:auto}"]
            }]
    }], function () { return []; }, { attributeControls: [{
            type: Input
        }], formArray: [{
            type: Input
        }], parentFormGroup: [{
            type: Input
        }], entityRelation: [{
            type: Input
        }], isSmallSize: [{
            type: Input
        }], readonly: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    AttributeTableComponent.prototype.isDetailModalShown;
    /** @type {?} */
    AttributeTableComponent.prototype.currentFormGroup;
    /** @type {?} */
    AttributeTableComponent.prototype.isErrorModalShown;
    /** @type {?} */
    AttributeTableComponent.prototype.errorTitle;
    /** @type {?} */
    AttributeTableComponent.prototype.errorDescription;
    /** @type {?} */
    AttributeTableComponent.prototype.attributeControls;
    /** @type {?} */
    AttributeTableComponent.prototype.formArray;
    /** @type {?} */
    AttributeTableComponent.prototype.parentFormGroup;
    /** @type {?} */
    AttributeTableComponent.prototype.entityRelation;
    /** @type {?} */
    AttributeTableComponent.prototype.isSmallSize;
    /** @type {?} */
    AttributeTableComponent.prototype.readonly;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/jor-angular.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class JorAngularComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
JorAngularComponent.ɵfac = function JorAngularComponent_Factory(t) { return new (t || JorAngularComponent)(); };
JorAngularComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: JorAngularComponent, selectors: [["dk-jor-angular"]], decls: 0, vars: 0, template: function JorAngularComponent_Template(rf, ctx) { }, styles: ["@import \"/src/assets/css/global.css\";"], encapsulation: 2 });
/** @nocollapse */
JorAngularComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(JorAngularComponent, [{
        type: Component,
        args: [{
                selector: 'dk-jor-angular',
                template: "<!-- html content -->\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["@import \"/src/assets/css/global.css\";"]
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/jor-angular.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class JorAngularModule {
}
JorAngularModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: JorAngularModule });
JorAngularModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function JorAngularModule_Factory(t) { return new (t || JorAngularModule)(); }, imports: [[
            CommonModule,
            HttpClientModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(JorAngularModule, { declarations: function () { return [JorAngularComponent, SearchHelpComponent, AttributeComponent, AttributeFormComponent, AttributeTableComponent, AttributeForm2Component]; }, imports: function () { return [CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule]; }, exports: function () { return [SearchHelpComponent, AttributeComponent, AttributeFormComponent, AttributeForm2Component, AttributeTableComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(JorAngularModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    JorAngularComponent,
                    SearchHelpComponent,
                    AttributeComponent,
                    AttributeFormComponent,
                    AttributeTableComponent,
                    AttributeForm2Component
                ],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                exports: [
                    SearchHelpComponent,
                    AttributeComponent,
                    AttributeFormComponent,
                    AttributeForm2Component,
                    AttributeTableComponent
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: jor-angular.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { Association, Attribute, AttributeBase, AttributeComponent, AttributeControlService, AttributeForm2Component, AttributeFormComponent, AttributeTableComponent, DataDomainH, DataDomainMeta, DataDomainValue, DataElementH, DataElementMeta, Entity, EntityMeta, EntityRelation, EntityService, EntityType, FieldsMappingPair, Involve, JorAngularModule, PartnerInstance, PartnerRole, Projection, QueryObject, Relation, RelationMeta, Relationship, RelationshipH, RelationshipInstance, RelationshipMeta, Role, RoleH, RoleMeta, RoleRelation, SearchHelp, SearchHelpComponent, SearchHelpField, SearchHelpFieldMeta, SearchHelpH, SearchHelpMeta, Selection, Sort, UiMapperService, DomainValueValidator as ɵa, JorAngularComponent as ɵb };

//# sourceMappingURL=jor-angular.js.map